/* EOS Önizleme — tema sürümü ==================================================
   Kişiye özel 925 gümüş takının canlı, DÜRÜST illüstrasyonu. Fotoğraf değildir
   ve fotoğraf gibi görünmez: fotoğrafik zemin, bokeh, zemin gölgesi yok. Buna
   karşılık metal, cilalanmış metal gibi okunmalıdır.

   Sözleşme (laboratuvar sürümüyle aynı):
     sahne(host, opts) -> denetleyici
     denetleyici.guncelle(kismiOpts) · .destroy() · .durum · .secenekler · .svg · .kutu

   Temaya uyarlarken yapılan DÖRT değişiklik:

   1) BİTİŞ TABLOSU BURADA YOK. Metal tonları `snippets/eos-onizleme-stil.liquid`
      içinde CSS özel özellikleri olarak yaşar ve ANA TON (`--m1`) tema ayarı
      `eos_renk_kodlari`dan gelir — renk kutucuğuyla aynı kaynak. Bu dosya yalnız
      `var(--mN)` okur, hiçbir hex taşımaz. Bu yüzden modül o snippet olmadan
      çalışmaz; her mount eden şablon onu da basar.
   2) `window.EOSOnizleme` ATANMAZ. Tema ES modülü kullanır; dışa verim
      `export` iledir ve ayrıca `<eos-onizleme>` özel elemanı tanımlanır.
   3) KESME HARFLER İTALİKTİR ve parçanın iki boş köşesinde kaligrafik birer
      kıvrım vardır ("Elegant Swirls" — sahibin sattığı stil). Gerekçe ve
      Türkçe kapsama kararı `KESIM_STIL` ile `SUS` tablolarının yanında yazılı.
      Kıvrımlar `susleme: false` ile kapatılabilir; tema ayarı
      `eos_onizleme_susleme` bunu `data-susleme` üzerinden taşır.
   4) ÇİZİM HER ÜRÜNDE YOKTUR. Hangi kişiselleştirme tiplerinde önizleme
      basılacağına `snippets/eos-onizleme-izin.liquid` karar verir (tema ayarı
      `eos_onizleme_tipleri`, varsayılan yalnız `iki-harf`). Bu modül o kararı
      BİLMEZ ve bilmemelidir: izin yoksa `<eos-onizleme>` elemanı sayfaya hiç
      basılmaz, dolayısıyla burada mount edilecek bir host da olmaz.

   Kurallar değişmedi: ölçüm YALNIZ Canvas TextMetrics (host gizliyken getBBox 0
   döner), rAF/IntersectionObserver/filtre yok, harfler tr-TR ile büyür,
   textLength asla, dürüstlük altyazısı kapatılamaz.

   Gerekçeler, opts tablosu ve bilinen sınırlar: lab-final/NOTLAR.md */

const NS = 'http://www.w3.org/2000/svg';
let SAYAC = 0;
const SW = 'stroke-width', LC = 'stroke-linecap', LJ = 'stroke-linejoin', DA = 'stroke-dasharray';
const NN = 'none', RD = 'round', TA = 'text-anchor', FF = 'font-family', FS = 'font-size', FW = 'font-weight';
const V = (n) => 'var(--' + n + ')';
const y2 = (v) => Math.round(v * 100) / 100;   /* yol verisi: 2 ondalık yeter */

/* 1 · BİTİŞ JETONLARI — tablo CSS'tedir (snippets/eos-onizleme-stil.liquid).
   Burada yalnız bilinen jeton adları durur; bilinmeyen bir renk handle'ı
   (tüccar "Bronz" eklerse) engellenmez, çünkü o kuralı da aynı snippet basar. */
const FINIS_ANAHTARLARI = ['gold', 'silver', 'siyah', 'rose-gold'];
const finisAnahtar = (v) => String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9-]/g, '') || 'gold';
const RENK_AD = { 'gold':'Altın', 'silver':'Gümüş', 'siyah':'Siyah', 'rose-gold':'Roz altın' };
const URUN_AD = { 'kolye':'kolye', 'bileklik':'makrome bileklik', 'anahtarlik':'anahtarlık' };
const KORDON = 'var(--kordon,#2C2823)';   /* mumlu ip; ton bitiş jetonundan gelir (eos-onizleme-stil), kordonRengi ile ezilir */

/* 2 · BURÇ SEMBOLLERİ — özgün çizgi çizimleri (font değil: U+2648–2653 emoji
   kod noktalarıdır, mor kutu basar). bb = mürekkep sınırı; ölçek bununla
   normalize edilir, yoksa glifler farklı boylarda görünür. */
const CIZGI = 7;
const BURCLAR = {
  koc:     { ad:'Koç',     bb:[21,18,79,84], d:'M50 84L50 44M50 44C50 26 40 18 31 21 22 24 21 38 28 46M50 44C50 26 60 18 69 21 78 24 79 38 72 46' },
  boga:    { ad:'Boğa',    bb:[27,22,73,83], d:'M27 22C27 52 73 52 73 22M31 64A19 19 0 1 0 69 64A19 19 0 1 0 31 64' },
  ikizler: { ad:'İkizler', bb:[30,20,70,80], d:'M30 24C40 20 60 20 70 24M30 76C40 80 60 80 70 76M38 22L38 78M62 22L62 78' },
  yengec:  { ad:'Yengeç',  bb:[20,26,84,75], d:'M20 40C32 28 52 26 68 33M72 38A4 4 0 1 0 80 38A4 4 0 1 0 72 38M80 61C68 73 48 75 32 68M20 63A4 4 0 1 0 28 63A4 4 0 1 0 20 63' },
  aslan:   { ad:'Aslan',   bb:[20,30,79,74], d:'M44 48C36 60 20 58 20 45 20 32 38 30 44 42 50 54 47 64 57 70 69 77 82 67 79 54' },
  basak:   { ad:'Başak',   bb:[24,26,76,74], d:'M24 68L24 34C24 26 34 26 34 34L34 68M34 34C34 26 44 26 44 34L44 68M44 34C44 26 56 26 58 36 62 52 58 66 46 74M50 54C62 50 74 58 76 72' },
  terazi:  { ad:'Terazi',  bb:[20,32,80,70], d:'M20 70L80 70M20 52L34 52M66 52L80 52M34 52C34 32 66 32 66 52' },
  akrep:   { ad:'Akrep',   bb:[22,30,76,70], d:'M22 70L22 38C22 30 32 30 32 38L32 70M32 38C32 30 42 30 42 38L42 70M42 38C42 30 54 30 54 38L54 66L76 46M64 46L76 46L76 58' },
  yay:     { ad:'Yay',     bb:[24,24,76,76], d:'M24 76L76 24M56 24L76 24L76 44M32 44L56 68' },
  oglak:   { ad:'Oğlak',   bb:[15,23,85,77], d:'M15 35C15 25 25 23 30 33L41 61L47 39C50 27 59 27 63 37L67 55C75 45 85 53 81 65 77 77 61 77 53 67' },
  kova:    { ad:'Kova',    bb:[18,30,82,68], d:'M18 42L34 30L50 42L66 30L82 42M18 68L34 56L50 68L66 56L82 68' },
  balik:   { ad:'Balık',   bb:[22,22,78,78], d:'M34 22C18 38 18 62 34 78M66 22C82 38 82 62 66 78M22 50L78 50' }
};

/* 2b · BURÇ FİGÜRLERİ — YALNIZ dikdörtgen levhanın panellerinde kullanılır.
   Sahibin fotoğraflarındaki parça burç GLİFİNİ değil, figüratif bir delik-işi
   (openwork) motifi taşıyor: İkizler bir profil + savrulan saç, Balık iki balık,
   Aslan bir aslan yüzü, Yengeç bir yengeç. Bu dördü fotoğraftan ölçülerek
   çizildi; kalan sekizi aynı dilde (kalın şerit, kapalı sayaçlar) sürdürüldü.

   Biçim: 100×100 kutu; her öğe [d, kalınlık] ya da [d, 0] (dolgu). Kalınlıklar
   saç teli değil ŞERİT: panel 53–85 px'e inince ince çizgi kayboluyor, kalın
   şerit hâlâ "kesilmiş metal" okunuyor. Yuvarlak madalyonun KAZINMIŞ glifleri
   (BURCLAR) değişmedi — sahibin ayrıca onayladığı biçim odur. */
function dalgaCember(cx, cy, r, n, amp, faz) {   /* yeleli/ışınlı kapalı halka */
  const N = n * 2, f = faz || 0, P = [], nok = (R, a) => y2(cx + R * Math.cos(a)) + ' ' + y2(cy + R * Math.sin(a));
  for (let i = 0; i < N; i++) P.push([f + i * Math.PI / n, r + (i % 2 ? -amp : amp)]);
  let d = 'M' + nok(P[0][1], P[0][0]);
  for (let i = 1; i <= N; i++) {
    const q = P[i % N], a0 = P[i - 1][0];
    d += 'Q' + nok(r - amp * .35, a0 + Math.PI / (2 * n)) + ' ' + nok(q[1], f + i * Math.PI / n);
  }
  return d + 'Z';
}
const F_YELE = dalgaCember(50, 50, 42, 7, 9, -Math.PI / 2);     /* aslan: iri tutam */
const F_YELE2 = dalgaCember(50, 50, 29, 7, 5.5, -Math.PI / 2 + Math.PI / 7);
const BURC_FIGUR = {
  /* ASLAN — fotoğraftaki (double-zodiac-charm-1, üst panel) cepheden aslan yüzü:
     iri yele tutamları, sivri kulaklar, badem gözler, üçgen burun, bıyıklar.
     Yedi tutam on birden daha okunur çıktı: on bir tutam 75 px panelde "güneş"
     okunuyordu. */
  aslan: [[F_YELE, 6.5], [F_YELE2, 5],
    ['M28 26c-4-10 1-15 9-11 5 3 7 8 6 13M72 26c4-10-1-15-9-11-5 3-7 8-6 13', 5.5],
    ['M36 45c5-3 9-2 11 2M64 45c-5-3-9-2-11 2', 5],
    ['M40 47a4 3 0 1 0 .1 0ZM60 47a4 3 0 1 0 .1 0Z', 0],
    ['M50 55 43 62h14Z', 0],
    ['M50 63c-7 0-10-3-11-6M50 63c7 0 10-3 11-6M50 63v5', 4.5],
    ['M38 68c-7 5-14 6-20 4M40 75c-6 6-12 8-18 8M62 68c7 5 14 6 20 4M60 75c6 6 12 8 18 8', 4],
    ['M35 57c-8 2-14 1-18-2M65 57c8 2 14 1 18-2', 4]],
  /* YENGEÇ — fotoğrafta (alt panel) iri kabuk, iki kaldırılmış kıskaç, yandan
     üçer bacak, iki göz sapı. */
  yengec: [
    ['M50 78a27 18 0 1 0-.1 0Z', 7],
    ['M42 57c-3-6-4-11-2-16M58 57c3-6 4-11 2-16M39 38a4 4 0 1 0 .1 0ZM61 38a4 4 0 1 0 .1 0Z', 5],
    ['M29 58C16 54 8 43 13 32c3-6 9-6 11-1M13 32 4 29M13 32l2-10M71 58c13-4 21-15 16-26-3-6-9-6-11-1M87 32l9-3M87 32l-2-10', 5.5],
    ['M26 68c-8 1-15 5-19 11M27 77c-7 3-12 8-15 14M74 68c8 1 15 5 19 11M73 77c7 3 12 8 15 14M31 58c-8-1-15-1-21 2M69 58c8-1 15-1 21 2', 4.5]],
  /* İKİZLER — fotoğrafta (double-zodiac-1, üst panel) sola bakan bir profil,
     hemen arkasında ikinci profil, ve sağ yarıyı boydan boya dolduran uzun
     dalgalı saç şeritleri. 75 px'lik panelde en güçlü işaret PARALEL ŞERİTLER:
     beş şerit, adım 6 birim, kalınlık 3,2 — daha kalını konturla birleşip
     tek kütleye dönüşüyor (ilk turda ölçüldü). */
  ikizler: [
    ['M57 15c-14 2-23 13-23 26 0 5-9 8-9 12 0 4 7 4 8 8 1 4-4 6-1 9 3 3 9 2 12 1 1 8 6 13 17 16', 6.5],
    ['M43 19c-11 4-18 13-18 23 0 4-7 6-7 10 0 3 5 4 6 7 1 3-3 5-1 7 2 3 7 2 9 1 1 6 5 11 12 14', 4.6],
    ['M66.4 0.1A52.0 52.0 0 0 1 66.4 91.9M63.1 6.3A45.0 45.0 0 0 1 63.1 85.7M59.8 12.4A38.0 38.0 0 0 1 59.8 79.6M56.6 18.6A31.0 31.0 0 0 1 56.6 73.4M53.3 24.8A24.0 24.0 0 0 1 53.3 67.2', 3.2],
    ['M51.4 28.3L68.3 -3.4', 3.4]],
  /* BALIK — iki balık, biri sağa biri sola, üst üste. Fotoğrafta gövdeler
     daire kurarak kıvrılıyor; 75 px'te o kıvrım "helezon" okunduğu için
     gövdeler düzleştirildi, kuyruk ve göz korundu: iki balık okuması kalıyor. */
  balik: [
    ['M30 34C42 20 62 19 75 31 63 45 43 46 30 34Z', 6],
    ['M70 66C58 80 38 81 25 69 37 55 57 54 70 66Z', 6],
    ['M30 34 6 22 13 34 6 46ZM70 66 94 78 87 66 94 54Z', 5],
    ['M65 31a3.2 3.2 0 1 0 .1 0ZM35 69a3.2 3.2 0 1 0 .1 0Z', 0],
    ['M50 42v16', 4.6]],
  koc: [
    ['M50 86V52', 7],
    ['M50 52c0-16-8-26-19-26-9 0-14 8-12 16 2 7 9 10 14 6M50 52c0-16 8-26 19-26 9 0 14 8 12 16-2 7-9 10-14 6', 7],
    ['M42 60a3.2 3.2 0 1 0 .1 0ZM58 60a3.2 3.2 0 1 0 .1 0Z', 0],
    ['M50 70c-4 0-6-2-7-4M50 70c4 0 6-2 7-4M44 82h12', 4.5]],
  boga: [
    ['M50 84a20 20 0 1 0-.1 0Z', 7],
    ['M30 64C18 58 12 44 16 30c6 6 14 8 20 6M70 64c12-6 18-20 14-34-6 6-14 8-20 6', 7],
    ['M43 60a3.2 3.2 0 1 0 .1 0ZM57 60a3.2 3.2 0 1 0 .1 0Z', 0],
    ['M50 72a5 4 0 1 0 .1 0Z', 4.5]],
  basak: [
    ['M48 20c-10 2-17 11-17 22 0 4-5 6-5 9 0 3 4 3 4 6 0 3-3 4-1 6 2 2 6 2 8 1 1 6 5 10 12 12', 6],
    ['M50 30c12 1 21 11 21 24 0 11-5 20-14 25M54 33c9 3 15 11 15 21 0 9-4 16-11 20', 4.5],
    ['M40 88c0-14 6-24 16-28M56 60c-2-8 0-14 5-18M56 68c0-8 3-13 9-16M56 76c1-8 5-12 11-14', 5]],
  terazi: [
    ['M50 22v10M22 32h56M50 32v40M34 86h32', 6.5],
    ['M22 32 12 56a12 12 0 0 0 20 0ZM78 32 68 56a12 12 0 0 0 20 0Z', 5.5],
    ['M50 72a7 7 0 1 0 .1 0Z', 5]],
  akrep: [
    ['M28 72c-6-8-6-18 0-26 6-8 16-10 24-6', 7],
    ['M52 40c8 4 12 12 12 20 0 10-4 18-2 24 3 8 12 10 18 4 5-5 5-13 0-18', 7],
    ['M84 66l8-4M84 66l2 9', 5],
    ['M28 46c-6-6-14-8-20-4M24 56c-7-2-14 0-18 5M30 66c-6 2-11 7-12 13', 5],
    ['M40 54a3 3 0 1 0 .1 0Z', 0]],
  yay: [
    ['M22 82 76 26', 7],
    ['M54 24h24v24', 7],
    ['M30 40 54 66', 6],
    ['M30 28c14 6 24 16 30 30-4-16-14-26-30-30Z', 5]],
  oglak: [
    ['M34 30c-10 6-14 18-10 30 4 12 16 18 28 14', 7],
    ['M34 30c-2-10 4-18 13-18 8 0 13 6 13 14 0 6-4 10-9 10', 7],
    ['M52 74c10 4 20 2 26-6 6-9 4-20-4-26-6-4-13-2-15 4-2 7 4 12 10 9', 7],
    ['M30 48a3.2 3.2 0 1 0 .1 0Z', 0]],
  kova: [
    ['M30 20h40l-6 30a14 14 0 0 1-28 0Z', 7],
    ['M22 66c7-7 14-7 21 0 7 7 14 7 21 0 7-7 12-7 16-2M22 82c7-7 14-7 21 0 7 7 14 7 21 0 7-7 12-7 16-2', 6.5]]
};

/* 3 · ÖLÇÜLER. Mini aynı çizim değildir: pah basamağı, softbox, örgü maskesi ve
   kazımanın yardımcı kopyaları düşer. Hero 52,5 cm ortasına kurulur; 45 yukarıda
   60 aşağıda, adım başına 13 px = çerçevenin %4,3'ü (b'de %0,8'di).

   `cR`  = çerçeveli (iki harf) kolye ucunun DIŞ yarıçapı
   `lW`  = kolyedeki dikdörtgen levhanın genişliği (yükseklik LEV.h ile türetilir)
   `kCR`/`kLW` = bileklikteki karşılıkları
   `ahR` = anahtarlık YARIK HALKASININ DIŞ yarıçapı. Anahtarlıkta parça ölçüsü
           buradan TÜRETİLİR: fotoğrafta yarık halka standart bir parçadır
           (D≈150 px her iki üründe de) ve kolye ucu ona göre oturur, tersi
           değil. `ahN` = kaba oval halka adedi. */
const OLCU = {
  hero: { mini:false, W:400, H:300, cx:200, zUst:-6, yb:62, pxCm:2.6, zKal:11, zAdim:17, hR:10, r:74,
          kutuW:250, kutuH:150, enKesim:170, kY:96, kBel:252, kKal:17, kR:34, orgu:5.4,
          cR:76, lW:88, kCR:31, kLW:40, ahR:37, ahN:4 },
  mini: { mini:true, W:96, H:72, cx:48, zUst:-2, yb:14, pxCm:.4, zKal:2.7, zAdim:4.5, hR:3.2, r:21,
          kutuW:68, kutuH:42, enKesim:48, kY:23, kBel:60.5, kKal:5, kR:9.8, orgu:2.1,
          cR:21.5, lW:24.5, kCR:9, kLW:11.5, ahR:10, ahN:2 }
};

/* ÇERÇEVE — iki harf / tek harf kolye ucu. Fotoğraftan ölçülen oranlar; dış
   yarıçap R = 1 kabul edildi (initials-1: R=80,8 px · initials-charm-1: R=81,0).
   Bant kalınlığı iki fotoğrafın ortancası: 13,4/80,8 ve 12,0/81,0 → 0,155 R. */
const CER = {
  t: .155,        /* halka bandının kalınlığı / R */
  tabR: .161,     /* tepedeki askı tabının DIŞ yarıçapı / R (ölçüm 13/80,8) */
  tabIc: .087,    /* tabın deliği / R (ölçüm 7/80,8) */
  tabY: 1.09,     /* tab merkezinin parça merkezine uzaklığı / R */
  rim: .058,      /* kesim kenarı konturu / R */
  yuz: .026,      /* koyu şerit (.058-.026)/2 = .016 R ≈ 1,2 px hero'da; fotoğrafta
                     parçanın kenar hattı 1-1,5 px (R=81 px). */
  kutuW: 2.02,    /* monogram mürekkep kutusu / R — harf halkanın kenarına değsin */
  kutuH: 1.94,
  kose2: 2.54,    /* iki harfte köşe sınırı: hypot(W,H) ≤ kose2·R */
  kose1: 2.14,    /* tek harf: kare kutu köşesi halkayı delmesin */
  /* Bindirme ve çapraz şaşırtma ÖLÇÜLEREK büyütüldü: karşılaştırmada iki harf
     yan yana duran iki harf gibi okunuyordu, referanstaki gibi TEK bir monogram
     gibi değil. Harfler artık birbirinin içine giriyor ve çapraz oturuyor. */
  bind: .62,      /* bindirme (dar harfin oranı) */
  dy: 10,         /* çapraz şaşırtma, em'in %'si: ilk harf yukarı, ikinci aşağı */
  kay: .09        /* kaynak dilinin kalınlığı / R */
};

/* "ELEGANT SWIRLS" KIVRIMLARI ve HALKA PAHI. Her iki tablo da R = 1 birim
   uzayında yazılıdır ve `snippets/eos-onizleme-cerceve-uc.liquid` içinde
   BİREBİR AYNISI durur: ilk boyama (Liquid) ile JS'in boyaması arasında
   şekil değişmesin diye çizim tek uzayda tanımlı, çağıran yalnız
   `translate(cx cy) scale(R)` uyguluyor. Bir sayı değişirse İKİSİ BİRDEN
   değişmelidir.

   SUS: halkanın İÇ kenarında (0,845 R) doğan, içeri doğru kıvrılan logaritmik
   spiral — 152°'de başlar, 268° döner, yarıçapı %24'e iner. Yarıçap aralığı
   0,56–0,85 R: harflerin yoğun olduğu ortayı BİLEREK boş bırakır, dış banda
   sokulur. Halkadan doğduğu için havada durmaz — kaynaklıdır, yani atölyenin
   kesebileceği bir parçadır. İkinci kopya 180° döndürülür: harfler çapraz
   durduğu için (dy ±7,5%) boş kalan iki köşe alt-sol ile üst-sağdır.
   İki parça = kaba ucu halkada, ince ucu içeride bir DARALMA.

   PAH: bant düz değildir. Üst-solda aydınlık bir iç dudak, alt-sağda koyu bir
   ufuk bandı, ikisinin arasında kısa bir speküler. [yol, jeton, kalınlık,
   opaklık]. Mini ölçekte hiç basılmaz (72 pikselde görünmez). */
const SUS = [
  ['M-0.746 0.397L-0.749 0.334L-0.734 0.279L-0.706 0.235L-0.669 0.205L-0.629 0.189L-0.59 0.186L-0.555 0.195', .072],
  ['M-0.565 0.191L-0.536 0.205L-0.515 0.224L-0.501 0.247L-0.495 0.27L-0.495 0.292L-0.502 0.312L-0.513 0.327L-0.526 0.337L-0.54 0.343', .038]
];
const PAH = [
  ['M-0.883 -0.062A0.885 0.885 0 0 1 0.332 -0.821', 'm2', .045, .5],
  ['M0.958 0.101A0.963 0.963 0 0 1 -0.392 0.88', 'm0', .042, .45],
  ['M-0.829 -0.404A0.923 0.923 0 0 1 -0.617 -0.686', 'hi', .05, .7],
  ['M0.843 0.375A0.923 0.923 0 0 1 0.746 0.542', 'hi', .038, .45]
];
/* LEVHA — iki burçlu dikdörtgen plaka. Genişlik W = 1 kabul edildi
   (double-zodiac-1: W=93,5 px · double-zodiac-charm-1: W=124,5 px). */
const LEV = {
  h: 1.92,        /* yükseklik / W (ölçüm 178,5/93,5 ve 242/124,5) */
  t: .075,        /* dış ray ve ORTA BANT kalınlığı / W (ölçüm 7/93,5 · 8/124,5) */
  kose: .055,     /* dış köşe yarıçapı / W (ölçüm ≈5/93,5) */
  icKose: .022,   /* panel iç köşesi */
  rim: .026,      /* kesim kenarı konturu / W — ray 0,075 W olduğu için kontur
                     İNCE olmalı: 0,052 W'de koyu şerit rayın üçte birini yiyor,
                     panel motifi de lapaya dönüyordu (ilk turda ölçüldü). */
  yuz: .010,
  tabR: .152,     /* askı halkasının ÇİZGİ yarıçapı → dış = 1,24·tabR = .188 W */
  tabY: .20,      /* halka merkezinin levha üst kenarının ÜSTÜNDEKİ yüksekliği / W */
  motif: 1.2      /* motif kutusunun panele oranı. Fotoğrafta motif panele DEĞER
                     ve raya kaynar; 100 birimlik kutunun içeriği 6-94 arasında
                     yaşadığı için 1,2 katsayısı onu panel kenarına taşır. Taşan
                     uç levha silüetine kırpılır, rayın ALTINDA kalır = kaynak. */
};
/* Panel iç ölçüsü: W(1-2t) = 0,85 W · (h-3t)/2 = 0,847 W → paneller KARE. */

/* ANAHTARLIK DONANIMI — yassı yarık halkanın DIŞ çapı D = 1 kabul edildi
   (initials-charm-1: D=152 px · double-zodiac-charm-1: D=148 px). */
const AH = {
  bant: .098,     /* yassı bandın kalınlığı / D (ölçüm 15/152) */
  bagR: .118,     /* bağlantı halkasının dış yarıçapı / D (ölçüm 18/152) */
  linkW: .185,    /* kaba oval halkanın dış genişliği / D (ölçüm 28/152) */
  adim: .296,     /* halka adımı / D (ölçüm 45/152) */
  tel: .043       /* tel kalınlığı / D (ölçüm 6,5/152) */
};

/* 4 · YARDIMCILAR ---------------------------------------------------------- */
function el(tag, a, ana) {
  const n = document.createElementNS(NS, tag);
  if (a) for (const k in a) { const v = a[k]; if (v != null) n.setAttribute(k, typeof v === 'number' ? y2(v) : v); }
  if (ana) ana.appendChild(n);
  return n;
}
const yaz = (n, s) => { n.textContent = s; return n; };
const bir = (a, b) => Object.assign({}, a, b);
function yay(cx, cy, r, d0, d1) {           /* 0° sağ, 90° aşağı */
  const a = d0 * Math.PI / 180, b = d1 * Math.PI / 180;
  return 'M' + y2(cx + r * Math.cos(a)) + ' ' + y2(cy + r * Math.sin(a)) + 'A' + y2(r) + ' ' + y2(r) +
    ' 0 ' + ((d1 - d0) > 180 ? 1 : 0) + ' 1 ' + y2(cx + r * Math.cos(b)) + ' ' + y2(cy + r * Math.sin(b));
}

/* Türkçe. Â Î Û izinli: Kâmil, Nûr, Lâle gerçek isimlerdir; onları eleyen bir
   süzgeç harf siler ve kimse fark etmez (c'nin kusuru). */
const IZIN = /[^A-Za-zÇĞİÖŞÜçğıöşüÂÎÛâîû0-9 .&'-]/g;
const nfc = (s) => { s = String(s == null ? '' : s); return s.normalize ? s.normalize('NFC') : s; };
const temizAd = (s) => nfc(s).replace(/[‘’ʼ]/g, "'").replace(IZIN, '').replace(/\s+/g, ' ').trim().slice(0, 22);
/* "i".toUpperCase() → "I" yanlıştır, tr-TR "İ" verir. ÖNCE temizle SONRA böl:
   tersi olursa 'e1ş' girişinde '1' elenince 'Ş' hiç görünmez. */
const harfle = (s, n) => Array.from(nfc(s).toLocaleUpperCase('tr-TR').replace(/[^A-ZÇĞİÖŞÜ]/g, '')).slice(0, n).join('');

/* Canvas mürekkep ölçümü — host gizliyken de doğru. Canvas font kısayolu
   CSS'ten katıdır: boşluklu TIRNAKSIZ bir aile adı atamanın TAMAMINI sessizce
   iptal eder, eski font yürürlükte kalır ve ölçüm yanlış çıkar. */
let CTX;
const aileNormalle = (a) => String(a).split(',').map((p) => {
  p = p.trim();
  return !p ? '' : (/^["']|^[\w-]+$/.test(p) ? p : '"' + p.replace(/["']/g, '') + '"');
}).filter(Boolean).join(', ');
function murekkep(str, aile, ag, stil) {
  if (CTX === undefined) {
    try { const c = document.createElement('canvas'); c.width = c.height = 8; CTX = c.getContext('2d'); } catch (_) { CTX = null; }
  }
  if (!CTX) { const w = Math.max(1, String(str || '').length) * 27; return { l:w, r:w, a:70, d:18 }; }
  CTX.font = '400 13px serif';                      /* nöbetçi: red edilen atamayı yakalar */
  CTX.font = (stil ? stil + ' ' : '') + (ag || 400) + ' 100px ' + aile;
  if (CTX.font.indexOf('100px') === -1) CTX.font = (ag || 400) + ' 100px serif';
  CTX.textAlign = 'center'; CTX.textBaseline = 'alphabetic';
  const m = CTX.measureText(str || ' ');
  const l = m.actualBoundingBoxLeft, r = m.actualBoundingBoxRight;
  const a = m.actualBoundingBoxAscent, d = m.actualBoundingBoxDescent;
  if (!isFinite(l) || !isFinite(r) || (l + r) <= 0) { const w = (m.width || 50) / 2; return { l:w, r:w, a:70, d:18 }; }
  return { l, r, a: isFinite(a) ? a : 70, d: isFinite(d) ? d : 0 };
}
/* x, text-anchor="middle" içindir ve İLERLEMEYİ değil MÜREKKEBİ ortalar
   (kazımada optik merkez budur; yoksa "Su" gibi kısa yazı sağa kayar). */
function capa(m, cx, cy, fs) {
  const k = fs / 100;
  return { fs, icx: cx, x: cx - (m.r - m.l) / 2 * k, y: cy + (m.a - m.d) / 2 * k, yW: (m.l + m.r) * k };
}
/* Mürekkep kutusunun KÖŞELERİ r çemberine otursun: fs = 200r/hypot(w,h).
   Kapalı form, iterasyon yok. */
function daireFit(s, aile, ag, cx, cy, r, enB) {
  const m = murekkep(s, aile, ag);
  return capa(m, cx, cy, Math.min(enB || 1e4, 200 * r / (Math.hypot(m.l + m.r, m.a + m.d) || 1)));
}
function kutuFit(s, aile, ag, cx, cy, mw, mh, enB) {
  const m = murekkep(s, aile, ag);
  return capa(m, cx, cy, Math.min(enB || 1e4, 100 * mw / (m.l + m.r || 1), 100 * mh / (m.a + m.d || 1)));
}
/* İki satır: bölme noktası KARAKTER SAYISIYLA değil ÖLÇÜLEN GENİŞLİKLE seçilir
   — geniş yarıyı en çok küçülten bölüm en büyük puntoyu verir (b'nin kusuru). */
function ikiyeBol(s, aile, ag) {
  const p = s.split(' ');
  if (p.length < 2) return null;
  let en = null, f = 1e9;
  for (let i = 1; i < p.length; i++) {
    const a = p.slice(0, i).join(' '), b = p.slice(i).join(' ');
    const ma = murekkep(a, aile, ag), mb = murekkep(b, aile, ag);
    const d = Math.max(ma.l + ma.r, mb.l + mb.r);
    if (d < f) { f = d; en = [a, b]; }
  }
  return en;
}
function satirFit(sat, aile, ag, cx, cy, r, enB) {
  const LH = 114, ms = sat.map((s) => murekkep(s, aile, ag));
  let W = 0;
  ms.forEach((m) => { W = Math.max(W, m.l + m.r); });
  const H = LH * (sat.length - 1) + ms[0].a + ms[ms.length - 1].d;
  const fs = Math.min(enB || 1e4, 200 * r / (Math.hypot(W, H) || 1)), k = fs / 100, u = cy - H * k / 2;
  return { fs, satir: sat.map((s, i) => ({ s, fs, x: cx - (ms[i].r - ms[i].l) / 2 * k, y: u + (ms[0].a + LH * i) * k })) };
}

/* 5 · AKSAN KAYNAĞI — en önemli düzeltme. Kesme harfte Ğ'nin çizgisi ve Ü/Ö'nün
   noktaları yazı tipinde AYRI adalardır; iki kopya kontur onları şişirir ama
   gövdeye BAĞLAMAZ. Üç adayın üçünde de "ĞÜ" havada duran metal toplarıyla
   çizildi: atölyenin üretemeyeceği bir parça, yani yalan. Çözüm atölyenin
   çözümü — işaret kendi AYAĞIYLA çizilir ve gövdeye kaynaklanır. Kazımada bu
   sorun yok (oluk kopmaz), orada gerçek harf yazılır. */
const UST_ISARET = { '\u0306':'breve', '\u0307':'nokta', '\u0308':'ikinokta' };
/* Ayak x'leri, harfin ÖLÇÜLEN yarı genişliğinin çarpanı olarak — yazı tipi
   değişse de ayak metalin üstüne basar: U'da iki dikme, O/G'de üst kavis. */
const AYAK = { 'I':[0], 'O':[-.42,.42], 'U':[-.78,.78], 'G':[-.46,.46], 'A':[0] };
const AKSAN_TEPE = { breve:1.40, nokta:1.24, ikinokta:1.24 };   /* × cap, kontur dahil */
/* KESME HARF İTALİKTİR — "Elegant Swirls". Sahibin fotoğraflarında (initials-1/2,
   initials-charm-1/3) harfler dik bir serif değil, uçları kıvrılan kaligrafik bir
   yazıdır. Ayrı bir webfont YÜKLENMEDİ: temannın başlık yüzünün İTALİK kesimi
   zaten `font_face` ile basılıyor (snippets/theme-styles-variables.liquid) ve
   Türkçenin tamamını kapsıyor — Türkçe kapsamayan bir script fontu seçmek
   Ç/Ğ/İ/Ö/Ş/Ü'yü kaçırırdı. Kaligrafik okumayı italik taban + aşağıdaki SUS
   kıvrımları birlikte kuruyor; ücretli bir swash yüzü gelirse `KESIM_STIL` ve
   `KESIM_AG` tek yerden değişir.

   İtalik taban AKSAN AYAKLARINI da kaydırır: harfin tepesi taban çizgisine göre
   sağa yatar, ayak ise ölçülen YARI GENİŞLİİĞE göre konur. Düzeltme yapılmazsa
   Ü'nün iki noktası dikmelerin soluna düşer ve "kaynak" yalan olur. */
const KESIM_STIL = 'italic';
const EGIM = .2;                 /* italik eğimin tanı — Playfair Italic ≈ 11° */
const aksanAyak = (taban, yw, cap) =>
  (AYAK[taban] || [-.45, .45]).map((f) => f * yw + cap * EGIM * .47);
function harfAyir(ch) {
  const d = ch && ch.normalize ? ch.normalize('NFD') : ch;
  let t = '', i = null;
  for (const c of d) { if (UST_ISARET[c]) i = UST_ISARET[c]; else t += c; }
  return { t: nfc(t), i };                  /* Ç/Ş'nin sedillası KALIR: zaten bitişik */
}
function aksanYol(isaret, taban, cap, yw) {
  const ay = aksanAyak(taban, yw, cap);
  const dip = -cap * .84, a0 = ay[0], a1 = ay[ay.length - 1];
  if (isaret === 'breve') return [{ d:'M' + y2(a0) + ' ' + y2(dip) + 'L' + y2(a0) + ' ' + y2(-cap * 1.12) +
    'Q0 ' + y2(-cap * 1.46) + ' ' + y2(a1) + ' ' + y2(-cap * 1.12) + 'L' + y2(a1) + ' ' + y2(dip), w: cap * .12 }];
  /* Nokta / iki nokta AYRI DİSK DEĞİLDİR. Önceki sürümde ince bir sapın ucunda
     geniş bir disk vardı: gövdeye kaynaklıydı ama "lolipop / toplu iğne"
     okunuyordu — çember çerçeve gelince harfler büyüdüğü için daha da belirgin
     oldu. Şimdi işaret, ucu yuvarlak KALIN bir tırnaktır: sap ile uç aynı
     genişlikte, oran 1:1. Lazer kesiminde de tek parça kalır. */
  return [{ d: ay.map((x) => 'M' + y2(x) + ' ' + y2(dip) + 'L' + y2(x) + ' ' + y2(-cap * 1.1)).join(''), w: cap * .13 }];
}

/* 6 · CSS — bu modülde YOK. Yerleşim, tipografi ve bitiş jetonlarının tamamı
   `snippets/eos-onizleme-stil.liquid` içindedir: ana ton oradan, tema ayarı
   `eos_renk_kodlari` üzerinden gelir, yani renk kutucuğu ile çizilen metal tek
   kaynaktan beslenir ve birbirinden kayamaz. Buraya bir yedek tablo koymak o
   tekliği bozardı; modül o snippet olmadan mount EDİLMEZ. */

/* 7 · DEGRADELER — örnek başına bir kez; kimlikler örnek sayacıyla öneklenir,
   yoksa sayfadaki ikinci önizleme ilkininkini çalar. Tek ışık yönü: sol üst.
   8 durak, çünkü iki duraklı degrade her zaman plastik görünür. */
const YUZ = [0, .14, .3, .42, .58, .76, .9, 1];
function degradeler(defs, id) {
  const gr = (a, ds) => {
    const g = el('linearGradient', bir(a, { id: id + a.id }), defs);
    ds.forEach((d) => el('stop', { offset: d[0], style:'stop-color:var(--' + d[1] + ')' }, g));
  };
  gr({ id:'f', x1:0, y1:0, x2:.35, y2:1 }, YUZ.map((o, i) => [o, 'm' + i]));
  gr({ id:'p', x1:0, y1:0, x2:0, y2:1 }, [[0,'m2'],[.5,'m4'],[1,'m6']]);
  gr({ id:'z', x1:0, y1:0, x2:1, y2:0 }, [[0,'m4'],[.25,'m2'],[.5,'m1'],[.75,'m6'],[1,'m4']]);
  /* Softbox + genel parlaklık b'ye göre KISILDI: madalyonun "madeni para / cam
     düğme" okumasının sebebi diski boydan boya kesen sert banttı. */
  const sb = el('radialGradient', { id: id + 's', cx:.5, cy:.5, r:.5 }, defs);
  el('stop', { offset:0, 'stop-color':'#fff', 'stop-opacity':.34 }, sb);
  el('stop', { offset:.58, 'stop-color':'#fff', 'stop-opacity':.13 }, sb);
  el('stop', { offset:1, 'stop-color':'#fff', 'stop-opacity':0 }, sb);
  const pr = el('radialGradient', { id: id + 'g', cx:.33, cy:.25, r:.56 }, defs);
  el('stop', { offset:0, 'stop-color':'#fff', 'stop-opacity':.26 }, pr);
  el('stop', { offset:1, 'stop-color':'#fff', 'stop-opacity':0 }, pr);
}
/* 8 · METAL İLKELLERİ ------------------------------------------------------ */
/* KABLO ZİNCİR. Ölçüm (initials-1): baklanın görünen genişliği 12 px, adımı
   18,8 px; kolye ucunun çapı 162 px → kal = 0,074 D, adim = 0,116 D. Eski çizim
   0,034 D kalınlıkta ve 0,108 D adımlıydı: kopuk noktalar dizisi okunuyordu,
   "zincir" değil. Baklalar BİTİŞİK olmalı — bu yüzden kesik boyu adımdan
   kalınlık kadar kısa, yuvarlak uç farkı kapatıyor. */
function zincir(g, d, id, kal, adim, mini) {
  const kes = Math.max(.4, adim - kal * .94), bos = Math.max(.35, adim - kes);
  const D2 = y2(kes) + ' ' + y2(bos);
  const L = (a) => el('path', bir({ d, fill:NN, [LC]:RD, [DA]: D2 }, a), g);
  L({ stroke:V('m0'), [SW]: kal });
  L({ stroke:'url(#'+id+'z)', [SW]: kal*.62 });
  if (mini) return;
  /* Halkanın deliği: baklanın ortasına gelen kısa koyu kesik. */
  L({ stroke:V('m0'), [SW]: kal*.2, [DA]: y2(kes*.42)+' '+y2(adim-kes*.42),
      'stroke-dashoffset': y2(-kes*.29), opacity:.8 });
  L({ stroke:V('m2'), [SW]: kal*.3, [DA]: y2(kes*.5)+' '+y2(adim-kes*.5),
      'stroke-dashoffset': y2(-kes*1.3), opacity:.9 });
  L({ stroke:V('hi'), [SW]: kal*.16, [DA]: y2(kes*.26)+' '+y2(adim-kes*.26),
      'stroke-dashoffset': y2(-kes*.34), opacity:.75 });
}
/* Zincir ÇERÇEVEYİ TERK EDER: karenin içinde yuvarlak kapaklarla biten zincir,
   boynun arkasından gelen zincir değil kesilmiş ip okunur (a'nın en pahalı kusuru). */
function kolyeD(W, y0, yb, x) {
  const x1 = W*.12, x2 = W*.88, h = yb - y0;
  return 'M' + y2(x1) + ' ' + y2(y0) + 'C' + y2(x1 + W*.015) + ' ' + y2(y0 + h*.62) + ' ' + y2(x - W*.155) + ' ' + y2(yb) + ' ' + y2(x) + ' ' + y2(yb) +
    'M' + y2(x) + ' ' + y2(yb) + 'C' + y2(x + W*.155) + ' ' + y2(yb) + ' ' + y2(x2 - W*.015) + ' ' + y2(y0 + h*.62) + ' ' + y2(x2) + ' ' + y2(y0);
}
function halka(g, id, cx, cy, r, mini) {
  el('circle', { cx, cy, r, fill:NN, stroke:V('m0'), [SW]: r*.48 }, g);
  if (!mini) el('circle', { cx, cy, r, fill:NN, stroke:'url(#'+id+'p)', [SW]: r*.28 }, g);
}
/* Kaynak kulbu: halka boşlukta kalmasın (b'de disk ile halka arasında boşluk
   vardı). Sıra: kulp → halka → disk; disk kulbun dibini örter, lehimli görünür. */
function kulp(g, id, cx, cyUst, r) {
  const w = r*.19, h = r*.15;
  el('path', { d:'M' + y2(cx - w/2) + ' ' + y2(cyUst + h*.5) + 'L' + y2(cx - w*.33) + ' ' + y2(cyUst - h) +
    'H' + y2(cx + w*.33) + 'L' + y2(cx + w/2) + ' ' + y2(cyUst + h*.5) + 'Z',
    fill:'url(#'+id+'f)', stroke:V('rim'), [SW]: Math.max(.6, r*.018), [LJ]:RD }, g);
}
function madalyon(g, defsG, id, ek, cx, cy, r, mini) {
  el('circle', { cx, cy, r: r + Math.max(.8, r*.022), fill:V('rim') }, g);
  el('circle', { cx, cy, r, fill:'url(#'+id+'f)' }, g);
  if (!mini) {
    el('circle', { cx, cy, r: r*.955, fill:NN, stroke:'url(#'+id+'p)', [SW]: r*.075, opacity:.95 }, g);
    el('circle', { cx, cy, r: r*.885, fill:NN, stroke:V('m0'), [SW]: Math.max(.5, r*.011), opacity:.38 }, g);
    el('path', { d: yay(cx, cy, r*.955, 190, 262), fill:NN, stroke:V('hi'), [SW]: r*.042, [LC]:RD, opacity:.42 }, g);
    el('path', { d: yay(cx, cy, r*.955, 42, 122), fill:NN, stroke:V('m6'), [SW]: r*.048, [LC]:RD, opacity:.42 }, g);
    const kid = id + 'k' + ek;
    el('circle', { cx, cy, r }, el('clipPath', { id: kid }, defsG));
    el('ellipse', { cx: cx - r*.24, cy: cy - r*.32, rx: r*.95, ry: r*.25,
      transform:'rotate(-32 ' + y2(cx - r*.24) + ' ' + y2(cy - r*.32) + ')', fill:'url(#'+id+'s)' },
      el('g', { 'clip-path':'url(#'+kid+')' }, g));
  }
  el('circle', { cx, cy, r, fill:'url(#'+id+'g)' }, g);
}
/* Kazıma, filtresiz: koyu kopya YUKARI (gölgeli üst duvar), açık kopya AŞAĞI
   (ışık alan dudak), oluk tabanı en üstte. Sıra bozulursa kabartma okunur. */
function kaziYazi(g, s, f, aile, ag, mini, tf) {
  const off = Math.max(.5, f.fs * .026);
  const t = { [FF]: aile, [FW]: ag, [FS]: f.fs, [TA]:'middle', x: f.x, 'xml:space':'preserve' };
  if (tf) t.transform = tf;
  if (!mini) {
    yaz(el('text', bir(t, { y: f.y + off, fill:V('hi'), style:'opacity:var(--kh)' }), g), s);
    yaz(el('text', bir(t, { y: f.y - off, fill:V('rim'), opacity:.95 }), g), s);
  }
  yaz(el('text', bir(t, { y: f.y, fill:V('rec') }), g), s);
}
function kaziGlif(g, kod, cx, cy, R, mini) {
  const b = BURCLAR[kod] || BURCLAR.koc;
  const k = 2 * R / Math.hypot(b.bb[2]-b.bb[0]+CIZGI, b.bb[3]-b.bb[1]+CIZGI);
  const kok = el('g', { transform:'translate(' + y2(cx) + ' ' + y2(cy) + ') scale(' + y2(k) + ') translate(' +
    y2(-(b.bb[0]+b.bb[2])/2) + ' ' + y2(-(b.bb[1]+b.bb[3])/2) + ')' }, g);
  const t = { d: b.d, fill:NN, [SW]: CIZGI, [LC]:RD, [LJ]:RD };
  if (!mini) {
    el('path', bir(t, { transform:'translate(0 2.4)', stroke:V('hi'), style:'opacity:var(--kh)' }), kok);
    el('path', bir(t, { transform:'translate(0 -2.4)', stroke:V('rim') }), kok);
  }
  el('path', bir(t, { stroke:V('rec') }), kok);
}
/* Kesme harf: geniş konturlu koyu kopya = kesim kenarı, dar konturlu yüz kopyası
   = gövde; aradaki ~0,017 em şerit parçayı gölgesiz ayırır ve tırnakları kaynatır.
   b'deki üçüncü "--hi dış hat" kopyası KALDIRILDI (içi boş akrilik okunuyordu). */
const KESIM_AG = 500, RIM_K = .072, YUZ_K = .038;
/* `kon` = [kesim kenarı konturu, yüz konturu] MUTLAK piksel. Çerçeve ve levhada
   kontur parçanın kendi ölçüsünden gelir (puntodan değil): halka bandı 0,155 R
   iken 0,072·fs'lik bir kontur bandı iki katına çıkarıyordu. */
function kesimParca(g, p, aile, boya, maskeMi, kon, pah, ag) {
  const ort = { [FF]: aile, 'font-style': KESIM_STIL, [FW]: ag || KESIM_AG, [FS]: p.fs, [TA]:'middle', x: p.x, y: p.y, [LJ]:RD, 'paint-order':'stroke', 'xml:space':'preserve' };
  const rw = kon ? kon[0] : p.fs * RIM_K, yw = kon ? kon[1] : p.fs * YUZ_K;
  const bas = (hedef, renk, w) => {
    if (p.aksan) p.aksan.forEach((a) => el('path', { d: a.d, fill:NN, stroke: renk, [SW]: a.w + w,
      [LC]:RD, [LJ]:RD, transform:'translate(' + y2(p.icx) + ' ' + y2(p.y) + ')' }, hedef));
    yaz(el('text', bir(ort, { fill: renk, stroke: renk, [SW]: w }), hedef), p.t);
  };
  /* PAH. Fotoğrafta ışık üst-soldan geliyor, bu yüzden kesim duvarı ALT-SAĞDA
     kalın ve koyu görünüyor; dört yanı eşit kalınlıkta koyu bir hat "vektröl
     çıkartma" okunuyordu. Aynı koyu kopyayı bir tık alt-sağa kaydırıp ALTINA
     basmak bunu tek düğümle verir: yeni renk, yeni filtre, yeni maske yok. */
  if (pah && !maskeMi) bas(el('g', { transform:'translate(' + y2(pah[0]) + ' ' + y2(pah[1]) + ')' }, g), V('m0'), rw);
  if (maskeMi) bas(g, '#fff', rw);
  else { bas(g, V('rim'), rw); bas(g, boya, yw); }
}

/* 9 · MONOGRAM — kesim kolye ucu ile madalyona kazınan monogram AYNI yerleşimi
   kullanır. Bindirme dar harfin %24'ü, taban çizgisi şaşırtması ±0,03 em (a'nın
   ±0,055'i "yanlış dizilmiş", sıfır ise "yan yana" okunuyordu). Kontur payı
   sığdırmaya dahildir. */
function harfOlc(ch, aile, kesim, ag) {
  const s = kesim ? harfAyir(ch) : { t: ch, i: null };
  const m = murekkep(s.t, aile, ag, kesim ? KESIM_STIL : null);
  return { t: s.t, i: s.i, m, gen: m.l + m.r, yw: (m.l + m.r) / 2, cap: m.a, alt: m.d,
           ust: s.i ? m.a * AKSAN_TEPE[s.i] : m.a };
}
function monogram(hs, aile, kesim, ag, maxW, maxH, enB, cx, cyRef, merkezMi, ayar) {
  ayar = ayar || {};
  const os = hs.map((h) => harfOlc(h, aile, kesim, ag)), pad = kesim ? (ayar.pad != null ? ayar.pad : RIM_K * 100) : 0;
  let W, H, yer;
  if (os.length < 2) { W = os[0].gen; H = os[0].ust + os[0].alt; yer = [[os[0], 0, 0]]; }
  else {
    /* Çerçevede bindirme ve çapraz şaşırtma BÜYÜK: fotoğrafta iki harf iç içe
       geçip kare bir mürekkep bloğu kuruyor, yan yana dizilmiyor. Madalyona
       KAZINAN monogram eski değerlerini korur (.24 / ±3). */
    const bind = (ayar.bind || .24) * Math.min(os[0].gen, os[1].gen), dy = ayar.dy != null ? ayar.dy : 3;
    W = os[0].gen + os[1].gen - bind;
    H = Math.max(os[0].ust + dy, os[1].ust - dy) + Math.max(os[0].alt - dy, os[1].alt + dy);
    yer = [[os[0], -W/2 + os[0].gen/2, -dy], [os[1], W/2 - os[1].gen/2, dy]];
  }
  let fs = Math.min(enB, 100 * maxW / (W + pad), 100 * maxH / (H + pad));
  /* Köşe sınırı: kare kutulu harfler (M, O, W) halkayı delip dışarı taşmasın.
     Kırpma zaten var ama kırpılan bir M "yarım harf" okunur. */
  if (ayar.kose) fs = Math.min(fs, 100 * ayar.kose / (Math.hypot(W + pad, H + pad) || 1));
  const k = fs / 100, p2 = ayar.p2 != null ? ayar.p2 : (kesim ? fs * RIM_K / 2 : 0);
  /* yer[i][2] TABAN ÇİZGİSİ kaymasıdır, mürekkep merkezi değil: ust/alt zaten
     taban çizgisinden ölçülür, ikisini karıştırmak parçayı kutunun altına
     taşırıyordu (ilk turda yakalandı). */
  let u = 1e9, a = -1e9;
  yer.forEach((q) => { u = Math.min(u, q[2]*k - q[0].ust*k); a = Math.max(a, q[2]*k + q[0].alt*k); });
  const kay = merkezMi ? cyRef - (u + a) / 2 : cyRef + p2 - u;
  let x0 = 1e9, x1 = -1e9;
  const ps = yer.map((q) => {
    const o = q[0], m = o.m, icx = cx + q[1] * k, y = q[2] * k + kay;
    x0 = Math.min(x0, icx - o.yw * k); x1 = Math.max(x1, icx + o.yw * k);
    return { t: o.t, fs, icx, y, x: icx - (m.r - m.l) / 2 * k, yw: o.yw * k, cap: o.cap * k,
             isaret: o.i, ust: y - o.ust * k - p2, alt: y + o.alt * k + p2,
             aksan: o.i ? aksanYol(o.i, o.t, o.cap * k, o.yw * k) : null };
  });
  let y0 = 1e9, y1 = -1e9, tepe = ps[0];
  ps.forEach((p) => { y0 = Math.min(y0, p.ust); y1 = Math.max(y1, p.alt); if (p.ust < tepe.ust) tepe = p; });
  return { fs, ps, x0, x1, y0, y1, tepe };
}
/* Örgü: A, sonra B üstüne, sonra A'nın orta bandı tekrar B'nin üstüne. Bant
   YUMUŞAK KENARLI MASKE ile alınır; sert kırpma Ş'yi düz çizgiyle kesiyordu. */
function bant(g, defsG, id, ek, x0, x1, y0, y1, ciz) {
  if (!(x1 > x0) || !(y1 > y0)) return;
  const gid = id + 'bg' + ek, mid = id + 'bm' + ek;
  const lg = el('linearGradient', { id: gid, gradientUnits:'userSpaceOnUse', x1: x0, y1:0, x2: x1, y2:0 }, defsG);
  [[0,0],[.22,1],[.78,1],[1,0]].forEach((s) => el('stop', { offset: s[0], 'stop-color':'#fff', 'stop-opacity': s[1] }, lg));
  const mk = el('mask', { id: mid, maskUnits:'userSpaceOnUse', x: x0, y: y0, width: x1-x0, height: y1-y0 }, defsG);
  el('rect', { x: x0, y: y0, width: x1-x0, height: y1-y0, fill:'url(#'+gid+')' }, mk);
  ciz(el('g', { mask:'url(#'+mid+')' }, g));
}
function monoCiz(g, defsG, id, ek, M, ciz, mini) {
  M.ps.forEach((p) => ciz(g, p));
  if (M.ps.length > 1 && !mini) bant(g, defsG, id, ek,
    M.ps[1].icx - M.ps[1].yw - M.fs*.03, M.ps[0].icx + M.ps[0].yw + M.fs*.03,
    M.y0 - 2, M.y1 + 2, (gg) => ciz(gg, M.ps[0]));
}

/* 9b · ÇERÇEVE, LEVHA ve ANAHTARLIK DONANIMI ================================
   Sahibin fotoğrafları iki gövdeyi değiştirdi. Aşağıdaki her sayı ölçümdür,
   gerekçesi CER / LEV / AH tablolarının yanında yazılı.

   Kesim dili tek: KOYU geniş kontur = kesim kenarı, dar yüz konturu = gövde.
   İkisi arasındaki şerit parçayı gölgesiz ayırır. kesimParca (harf) ile
   kesimDolgu / kesimSerit (yol) aynı iki kopyayı basar, bu yüzden halka, levha,
   motif ve harf TEK parça metal okunur. */
function kesimDolgu(g, d, boya, kon, kural) {        /* dolu kesim parçası */
  const o = { d, [LJ]:RD, [LC]:RD, 'paint-order':'stroke' };
  if (kural) o['fill-rule'] = kural;
  el('path', bir(o, { fill:V('rim'), stroke:V('rim'), [SW]: kon[0] }), g);
  el('path', bir(o, { fill: boya, stroke: boya, [SW]: kon[1] }), g);
}
function kesimSerit(g, d, w, boya, kon) {            /* w kalınlığında şerit */
  const o = { d, fill:NN, [LJ]:RD, [LC]:RD };
  el('path', bir(o, { stroke:V('rim'), [SW]: w + kon[0] }), g);
  el('path', bir(o, { stroke: boya, [SW]: w + kon[1] }), g);
}
/* Kıvrım ve pah R = 1 uzayında çizilir. Dolgusu userSpaceOnUse bir degrade
   olduğu için ÖLÇEKLİ grupta ayrı bir degrade gerekir: dışarıdaki degradenin
   koordinatları da ölçeklenir ve kıvrım parçanın geri kalanından başka
   ışık alır (aynı tuzak panel motifinde de var, bkz. uzayDegrade). */
function susleme(g, defsG, id, ek, cx, cy, R, maske) {
  /* `maske`: aynı yollar softbox maskesine de basılır, yoksa kıvrım parçanın
     geri kalanının aldığı ışığı almaz ve "sonradan eklenmiş çizgi" okunur. */
  const boya = maske ? null : uzayDegrade(defsG, id, 'su' + ek, -1, -1, 1, 1);
  const tr = 'translate(' + y2(cx) + ' ' + y2(cy) + ') scale(' + y2(R) + ')';
  [tr, tr + ' rotate(180)'].forEach((t) => {
    const gg = el('g', { transform: t }, g);
    /* Önce iki koyu kopya, SONRA iki yüz kopyası: tek tek basılırsa ikinci
       parçanın kesim kenarı birincinin yüzünün üstüne düşer ve daralmanın
       ortasında koyu bir dikiş görünür. */
    SUS.forEach((q) => el('path', { d: q[0], fill:NN, stroke: maske ? '#fff' : V('rim'), [SW]: q[1] + CER.rim, [LC]:RD, [LJ]:RD }, gg));
    if (!maske) SUS.forEach((q) => el('path', { d: q[0], fill:NN, stroke: boya, [SW]: q[1] + CER.yuz, [LC]:RD, [LJ]:RD }, gg));
  });
}
function halkaPahi(g, cx, cy, R) {
  const gg = el('g', { transform:'translate(' + y2(cx) + ' ' + y2(cy) + ') scale(' + y2(R) + ')' }, g);
  PAH.forEach((q) => el('path', { d: q[0], fill:NN, stroke:V(q[1]), [SW]: q[2], [LC]:RD, opacity: q[3] }, gg));
}
const cemberD = (cx, cy, r) => 'M' + y2(cx - r) + ' ' + y2(cy) + 'A' + y2(r) + ' ' + y2(r) +
  ' 0 1 0 ' + y2(cx + r) + ' ' + y2(cy) + 'A' + y2(r) + ' ' + y2(r) + ' 0 1 0 ' + y2(cx - r) + ' ' + y2(cy);
function yuvRect(x, y, w, h, r) {
  r = Math.min(r, w / 2, h / 2);
  const X2 = x + w, Y2 = y + h, A = 'A' + y2(r) + ' ' + y2(r) + ' 0 0 1 ';
  return 'M' + y2(x + r) + ' ' + y2(y) + 'H' + y2(X2 - r) + A + y2(X2) + ' ' + y2(y + r) +
    'V' + y2(Y2 - r) + A + y2(X2 - r) + ' ' + y2(Y2) + 'H' + y2(x + r) + A + y2(x) + ' ' + y2(Y2 - r) +
    'V' + y2(y + r) + A + y2(x + r) + ' ' + y2(y) + 'Z';
}
/* userSpaceOnUse degrade, İSTENEN uzayda. Ölçekli bir grubun içinde kullanılan
   degradenin koordinatları da ölçeklenir; motif grubuna girerken koordinatları
   önceden geri dönüştürüyoruz, yoksa panel motifi levhadan farklı ışık alır. */
function uzayDegrade(defsG, id, adi, x0, y0, x1, y1) {
  const g = el('linearGradient', { id: id + adi, gradientUnits:'userSpaceOnUse',
    x1: x0, y1: y0, x2: x0 + (x1 - x0) * .35, y2: y1 }, defsG);
  YUZ.forEach((o, i) => el('stop', { offset: o, style:'stop-color:var(--m' + i + ')' }, g));
  return 'url(#' + id + adi + ')';
}

/* ÇERÇEVELİ KOLYE UCU — iki harf / tek harf.
   Fotoğraf: ince AÇIK halka, içine kilitlenmiş harfler, harf uçları halkaya
   KAYNAR. Tepede delikli bir tab; askı halkası o delikten geçer. Ölçüm:
   R = 80,8 px, bant 13,4 px (0,166 R) · charm'da R = 81,0, bant 12,0 (0,148 R). */
function cerceveUc(g, defsG, id, ek, hs, aile, cx, cy, R, mini, bos, sus, tab, duz) {
  /* Bant: kesim konturu silüeti kon[0]/2 kadar BÜYÜTTÜĞÜ için yol kalınlığı
     t − kon[0] verilir; basılan bandın dışı tam R, kalınlığı tam 0,155 R olur.
     İlk turda bu düzeltilmeden bant %48 kalın çıkıyordu. */
  /* Düz çizimde kesim kenarı konturu inceltilir ve harf bir kademe hafif
     kesilir: kalın kontur + 500 ağırlık tek renkte siyah bir kütle üretiyordu,
     referanstaki monogram ise halkanın içini boş bırakan AÇIK bir çizgi işi. */
  /* Düz çizimde kesim konturu neredeyse sıfırlanır: el yazısı yüzün ince
     bağlantı çizgileri, metal modundaki kalın kenar konturuyla birlikte kalın
     bir kütleye dönüşüyordu. Kontur = yüzün kendi kalem kontrastı. */
  /* El yazısı yüzün ince bağlantıları ATÖLYEDE KESİLEMEZ: çizime bir miktar
     kalınlık verilir ki gösterilen parça üretilebilir bir parça olsun. Değer
     ölçülerek bulundu — 0,012 R'de çizim kalem işi, 0,058 R'de (metal modu)
     siyah kütle oluyordu. */
  const kon = duz ? [R * .03, R * .015] : [R * CER.rim, R * CER.yuz];
  const ag = duz ? 400 : KESIM_AG;
  /* Düz çizimde harf kutusu KÜÇÜLÜR, bant KALINLAŞIR: ölçekli karşılaştırmada
     halkayı dolduran harf tek renkte siyah bir kütle oluyor, referanstaki
     monogram ise kalın bir halkanın içinde nefes alan bir çizgi işi. */
  const kutuW = duz ? 1.76 : CER.kutuW, kutuH = duz ? 1.66 : CER.kutuH;
  const kose2 = duz ? 2.3 : CER.kose2, kose1 = duz ? 1.9 : CER.kose1;
  const t = R * (duz ? .175 : CER.t), Rm = R - t / 2;
  const tek = hs.length < 2;
  const M = monogram(hs, aile, true, ag,
    R * kutuW - kon[0], R * kutuH - kon[0], R * 2.4, cx, cy, true,
    { bind: CER.bind, dy: tek ? 0 : CER.dy, kose: R * (tek ? kose1 : kose2),
      pad: 0, p2: kon[0] / 2 });
  const boya = uzayDegrade(defsG, id, 'cf' + ek, cx - R, cy - R, cx + R, cy + R);
  /* Kırpma: taşan bir serif halkanın DIŞ hattında biter — gerçek kesim parçası
     da öyledir. Kırpmadan sonra dış kontur ayrıca basılır, yoksa taşan yerde
     koyu hat kopar. */
  const kid = id + 'cc' + ek;
  el('circle', { cx, cy, r: R }, el('clipPath', { id: kid }, defsG));
  const gk = el('g', { 'clip-path':'url(#' + kid + ')' }, g);
  kesimSerit(gk, cemberD(cx, cy, Rm), t - kon[0], boya, kon);
  /* Bantın pahı ve speküleri harflerden ve kıvrımlardan ÖNCE basılır. Parça
     tek sac levhadan kesiliyor: harfin halkaya kaynadığı yerde kesim kenarı
     YOKTUR, metal kesintisizdir. Pahı en sona koymak orada bir kenar çizgisi
     uydurur ve harf halkanın ARKASINDAN geçiyormuş gibi okunur. */
  if (!mini) halkaPahi(gk, cx, cy, R);
  /* Kıvrımlar harflerin ALTINA basılır: üstüne basılınca kesim kenarları
     harfin yüzünü bölüp "iki ayrı parça" okutuyor; altına basılınca harf
     kıvrımın önünden geçiyor ve fotoğraftaki iç içe geçme okuması çıkıyor. */
  if (sus && !mini) susleme(gk, defsG, id, ek, cx, cy, R);
  if (!bos) {
    /* Kaynak dili: en tepedeki ve en dipteki mürekkepten halkaya. Harf zaten
       halkayı kesiyorsa dil sıfır boya iner — görünmez. Dilsiz bir tasarım
       "halkanın içinde yüzen harf" olurdu: atölyenin üretemeyeceği parça. */
    let tepe = M.ps[0], dip = M.ps[0];
    M.ps.forEach((p) => { if (p.ust < tepe.ust) tepe = p; if (p.alt > dip.alt) dip = p; });
    const dikey = (x, y0, y1, w) => { if (y1 < y0 - .4) kesimSerit(gk, 'M' + y2(x) + ' ' + y2(y0) + 'L' + y2(x) + ' ' + y2(y1), w, boya, kon); };
    /* Aksanlı harfte tepe kaynağı İŞARETİN KENDİ AYAĞIYLA yapılır: ayrı bir
       kalın dil, noktayı bir direğin ucunda gibi gösteriyordu. İşaret zaten
       parçanın en tepesi; onu halkaya kendi kalınlığında uzatınca tek kesintisiz
       tırnak okunuyor ve "aksan halkaya çarpıyor" sorunu da kapanıyor. */
    let aksanKaynak = false;
    M.ps.forEach((p) => {
      if (!p.aksan || p.isaret === 'breve') return;
      const ust = p.y - p.cap * 1.1, w = p.cap * .13;
      aksanAyak(p.t, p.yw, p.cap).forEach((ax) => {
        const x = p.icx + ax, dx = x - cx;
        if (Math.abs(dx) >= Rm) return;
        dikey(x, ust, cy - Math.sqrt(Rm * Rm - dx * dx), w);
        aksanKaynak = true;
      });
    });
    const noktalar = [[dip.icx, dip.alt]];
    if (!(tepe.aksan && aksanKaynak)) noktalar.push([tepe.icx, tepe.ust]);
    /* Kaynak dili DÜZ değil KAVİSLİ. Düz şerit "sonradan yapıştırılmış destek"
       okunuyordu; fotoğrafta kaynak harfin kendi hattının devamı gibi hafifçe
       yaylanır. Yayın yönü boşluğun dikiyle alınıyor: tepe ve dip dilleri
       ters yöne yaylanıp parçanın çapraz kompozisyonunu sürdürüyor. Boşluk
       kapanınca (harf halkaya değiyorsa) yay da sıfıra iniyor. */
    noktalar.forEach((q) => {
      const dx = q[0] - cx, dy = q[1] - cy, L = Math.hypot(dx, dy);
      if (!(L > 1 && L < Rm)) return;
      const ex = cx + dx * Rm / L, ey = cy + dy * Rm / L, yay2 = (Rm - L) * .34;
      kesimSerit(gk, 'M' + y2(q[0]) + ' ' + y2(q[1]) + 'Q' +
        y2((q[0] + ex) / 2 - dy / L * yay2) + ' ' + y2((q[1] + ey) / 2 + dx / L * yay2) + ' ' +
        y2(ex) + ' ' + y2(ey), R * CER.kay, boya, kon);
    });
    const pah = mini ? null : [R * .02, R * .026];
    monoCiz(gk, defsG, id, ek + 'c', M, (gg, p) => kesimParca(gg, p, aile, boya, false, kon, pah, ag), mini);
    if (!mini) {                       /* parçanın silüetine maskelenmiş softbox */
      const sid = id + 'cs' + ek;
      const mk = el('mask', { id: sid, maskUnits:'userSpaceOnUse', x: cx - R - 4, y: cy - R - 4, width: 2 * R + 8, height: 2 * R + 8 }, defsG);
      el('path', { d: cemberD(cx, cy, Rm), fill:NN, stroke:'#fff', [SW]: t }, mk);
      if (sus) susleme(mk, defsG, id, ek, cx, cy, R, true);
      M.ps.forEach((p) => kesimParca(mk, p, aile, '#fff', true, kon, null, ag));
      el('ellipse', { cx: cx - R * .18, cy: cy - R * .3, rx: R * .96, ry: R * .26,
        transform:'rotate(-32 ' + y2(cx - R * .18) + ' ' + y2(cy - R * .3) + ')', fill:'url(#' + id + 's)' },
        el('g', { mask:'url(#' + sid + ')' }, gk));
    }
  } else bosAlan(gk, cx, cy, (R - t) * .86, mini);
  /* Dış kontur: tabın oturduğu tepe dilimi ATLANIR, yoksa tabın üstünden koyu
     bir yay geçer ve lehimli lug ayrı bir parça gibi okunur. */
  el('path', { d: tab === false ? yay(cx, cy, R - (kon[0] - kon[1]) / 4, 0, 360)
      : yay(cx, cy, R - (kon[0] - kon[1]) / 4, 283, 617), fill:NN,
    stroke:V('rim'), [SW]: (kon[0] - kon[1]) / 2 }, g);
  /* Tab: parçanın kendisiyle aynı metal, dibi halkanın yüzü tarafından örtülür.
     Bileklikte tab YOKTUR: fotoğrafta parça ipin içine iki yandaki halkalarla
     dizilir, üstünden sarkmaz. */
  if (tab !== false) {
    const tR = R * CER.tabR, tIc = R * CER.tabIc, ty = cy - R * CER.tabY;
    kesimSerit(g, cemberD(cx, ty, (tR + tIc) / 2), tR - tIc - kon[0], boya, kon);
  }
  return { fs: M.fs, en: R * 2 };
}

/* DİKDÖRTGEN LEVHA — iki burç.
   Fotoğraf: portre dikdörtgen, yuvarlatılmış köşe, ince dış ray, yatay bir
   bantla İKİ KARE panele bölünmüş, her panelde figüratif delik-işi motif.
   Ölçüm: W=93,5 H=178,5 ray 7 (dz-1) · W=124,5 H=242 ray 8 (dz-charm-1). */
function levhaUc(g, defsG, id, ek, o, cx, yUst, W, mini, bos) {
  const H = W * LEV.h, t = W * LEV.t, kon = [W * LEV.rim, W * LEV.yuz];
  const x0 = cx - W / 2, panW = W - 2 * t, panH = (H - 3 * t) / 2, ic = W * LEV.icKose;
  const boya = uzayDegrade(defsG, id, 'lf' + ek, x0, yUst, x0 + W, yUst + H);
  const pcy = [yUst + t + panH / 2, yUst + 2 * t + panH * 1.5];
  const kid = id + 'lk' + ek;
  el('path', { d: yuvRect(x0, yUst, W, H, W * LEV.kose) }, el('clipPath', { id: kid }, defsG));
  const gk = el('g', { 'clip-path':'url(#' + kid + ')' }, g);
  /* SIRA: önce motif, SONRA çerçeve. Çerçevenin dolu rayları motifin panelden
     taşan ucunu örter — kırpma çizgisi yok, ray ile motif TEK metal okunur.
     Ters sırada motifin koyu konturu rayların üstünden geçiyordu. */
  if (!bos) {
    const boy = Math.min(panW, panH) * LEV.motif;
    figurCiz(gk, defsG, id, ek + 'a', o.burc, cx, pcy[0], boy, x0, yUst, W, H, kon, mini);
    figurCiz(gk, defsG, id, ek + 'b', o.burc2, cx, pcy[1], boy, x0, yUst, W, H, kon, mini);
  }
  /* Panel delikleri kon[0]/2 BÜYÜK verilir: kesim konturu deliği o kadar
     daraltır, böylece basılan ray tam LEV.t kalır. */
  const d2 = kon[0] / 2;
  kesimDolgu(gk, yuvRect(x0 + d2, yUst + d2, W - kon[0], H - kon[0], W * LEV.kose) +
    yuvRect(x0 + t - d2, yUst + t - d2, panW + kon[0], panH + kon[0], ic) +
    yuvRect(x0 + t - d2, yUst + 2 * t + panH - d2, panW + kon[0], panH + kon[0], ic), boya, kon, 'evenodd');
  if (bos) pcy.forEach((y) => el('rect', { x: x0 + t + panW * .12, y: y - panH * .38, width: panW * .76,
    height: panH * .76, rx: ic, fill:NN, stroke:'var(--eos-gold-deep,#A8813F)', [SW]: mini ? 1 : 1.5,
    [DA]: mini ? '3 3' : '7 6', opacity:.5 }, gk));
  if (!mini) el('ellipse', { cx: cx - W * .2, cy: yUst + H * .22, rx: W * 1.1, ry: H * .12,
    transform:'rotate(-24 ' + y2(cx - W * .2) + ' ' + y2(yUst + H * .22) + ')', fill:'url(#' + id + 's)' }, gk);
  return { fs: Math.min(panW, panH), en: Math.min(panW, panH) };
}
/* Panel motifi: 100×100 kutuda çizilir, panele ölçeklenir. Degrade koordinatları
   ölçek geri alınarak veriliyor (bkz. uzayDegrade), böylece motif levhayla AYNI
   ışığı alır ve ayrı bir rozet gibi okunmaz. */
function figurCiz(g, defsG, id, ek, kod, cx, cy, boy, lx, ly, lw, lh, kon, mini) {
  const f = BURC_FIGUR[kod] || BURC_FIGUR.koc, k = boy / 100;
  const tx = cx - boy / 2, ty = cy - boy / 2;
  const kok = el('g', { transform:'translate(' + y2(tx) + ' ' + y2(ty) + ') scale(' + y2(k) + ')' }, g);
  const boya = uzayDegrade(defsG, id, 'mf' + ek, (lx - tx) / k, (ly - ty) / k, (lx + lw - tx) / k, (ly + lh - ty) / k);
  const kl = [kon[0] / k, kon[1] / k], az = mini ? 1 : 0;
  f.forEach((q, i) => {
    /* Mini'de son katmanlar düşer. Sınır 4: İkizler'in saç bandı (4. öğe) tüm
       şeritleri birbirine bağlayan parça, düşerse motif adacıklara ayrılır. */
    if (az && i > 3) return;
    if (q[1] > 0) kesimSerit(kok, q[0], q[1], boya, kl);
    else kesimDolgu(kok, q[0], boya, kl);
  });
}

/* YASSI YARIK HALKA — anahtarlığın standart parçası. Fotoğrafta tel değil YASSI
   bant (D=152 px, bant 15 px) ve bir tur daha dönen ikinci sarım görünür. */
function yarikHalka(g, id, cx, cy, R, mini) {
  const b = 2 * R * AH.bant, Rm = R - b / 2;
  el('circle', { cx, cy, r: Rm, fill:NN, stroke:V('m0'), [SW]: b }, g);
  el('circle', { cx, cy, r: Rm, fill:NN, stroke:'url(#' + id + 'p)', [SW]: b * .74 }, g);
  if (mini) return;
  el('path', { d: yay(cx, cy, Rm - b * .2, 152, 428), fill:NN, stroke:V('m0'), [SW]: b * .46 }, g);
  el('path', { d: yay(cx, cy, Rm - b * .2, 152, 428), fill:NN, stroke:V('m2'), [SW]: b * .24, opacity:.75 }, g);
  el('path', { d: yay(cx, cy, Rm, 196, 252), fill:NN, stroke:V('hi'), [SW]: b * .2, [LC]:RD, opacity:.5 }, g);
}
/* KABA OVAL ZİNCİR — anahtarlıkta zincir birkaç KALIN halkadır. Halkalar sırayla
   düz ve yandan durur; ölçüm: dış genişlik 28 px, adım 45 px, tel 6,5 px
   (yarık halka çapı 152 px). Dönen değer: son halkanın merkezi. */
function kabaZincir(g, id, cx, y0, D, n, mini) {
  const w = D * AH.linkW, adim = D * AH.adim, tel = D * AH.tel, uz = adim + 2 * tel;
  halka(g, id, cx, y0, D * AH.bagR / 1.24, mini);
  for (let i = 0; i < n; i++) {
    const cy = y0 + adim * (i + 1), duz = i % 2 === 0;
    const rx = duz ? Math.max(tel * .7, w / 2 - tel / 2) : tel * .62, ry = uz / 2 - tel / 2;
    el('ellipse', { cx, cy, rx, ry, fill:NN, stroke:V('m0'), [SW]: tel }, g);
    el('ellipse', { cx, cy, rx, ry, fill:NN, stroke:'url(#' + id + 'p)', [SW]: tel * .58 }, g);
    if (!mini) el('path', { d: yay(cx, cy, (rx + ry) / 2, 198, 246), fill:NN, stroke:V('hi'),
      [SW]: tel * .24, [LC]:RD, opacity:.55 }, g);
  }
  return y0 + adim * n;
}

/* 10 · MADALYON İÇERİĞİ. Kazıma alanı 0,72 r (pah 0,955 r): en kötü durumda
   kenara ~0,16 r pay kalır. b'nin 0,80'i pahı kesiyor, c'nin 0,66'sı küçültüyordu. */
const KAZI_R = .72;
function madalyonIcerik(g, defsG, id, ek, o, cx, cy, r, aile, mini) {
  const rk = r * KAZI_R, enB = r * .66;
  if (o.tip === 'zodyak') { kaziGlif(g, o.burc, cx, cy, r*.62, mini); return { fs: r*.62, en: r*.62 }; }
  if (o.tip === 'farkli-zodyak') {
    /* İki sembol iç içe: yarıçap 0,29 r, merkez ±0,26/±0,13 r → en uzak nokta
       0,58 r. c'de 0,92 r ile karmakarışıktı. */
    const boy = r*.29, ax = cx - r*.26, ay = cy - r*.13, bx = cx + r*.26, by = cy + r*.13;
    kaziGlif(g, o.burc, ax, ay, boy, mini);
    kaziGlif(g, o.burc2, bx, by, boy, mini);
    if (!mini) bant(g, defsG, id, ek+'z', cx - r*.06, cx + r*.42, cy - r*.4, cy + r*.16,
      (gg) => kaziGlif(gg, o.burc, ax, ay, boy, mini));
    return { fs: boy, en: boy };
  }
  if (o.tip === 'iki-harf' || o.tip === 'tek-harf') {
    const hs = Array.from(harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1));
    const M = monogram(hs, aile, false, 400, rk * 1.62, rk * .95, enB * 1.3, cx, cy, true);
    monoCiz(g, defsG, id, ek+'h', M, (gg, p) => kaziYazi(gg, p.t, p, aile, 400, mini), mini);
    return { fs: M.fs, en: enB * 1.3 };
  }
  if (o.tip === 'iki-isim') {
    /* İki ad tek madalyona: AYNI punto (farklı punto "dizgi kazası" okunur),
       eğim ±3,5° (±7 yanlış basılmış görünüyordu), dikey örtüşme ~%15. */
    const s1 = temizAd(o.isim), s2 = temizAd(o.isim2), dy1 = -r*.13, dy2 = r*.15;
    const kiris = (dy) => { const h = Math.min(rk*.94, Math.abs(dy) + r*.19); return Math.sqrt(Math.max(1, rk*rk - h*h)) * 1.92; };
    const fs = Math.min(kutuFit(s1, aile, 400, cx, cy+dy1, kiris(dy1), r*.4, enB).fs,
                        kutuFit(s2, aile, 400, cx, cy+dy2, kiris(dy2), r*.4, enB).fs);
    const f1 = capa(murekkep(s1, aile, 400), cx, cy + dy1, fs), f2 = capa(murekkep(s2, aile, 400), cx, cy + dy2, fs);
    const d1 = 'rotate(-3.5 ' + y2(cx) + ' ' + y2(cy) + ')';
    kaziYazi(g, s1, f1, aile, 400, mini, d1);
    kaziYazi(g, s2, f2, aile, 400, mini, 'rotate(3.5 ' + y2(cx) + ' ' + y2(cy) + ')');
    if (!mini) bant(g, defsG, id, ek+'i', cx - r*.92, cx + r*.1, cy - r*.55, cy + r*.14,
      (gg) => kaziYazi(gg, s1, f1, aile, 400, mini, d1));
    return { fs, en: enB };
  }
  /* tek-isim: hangisi daha BÜYÜK punto veriyorsa o (%6 histerezis). Tek kelimelik
     uzun ad bölünemez: küçülür ve durum.cokUzun ile host'a bildirilir. */
  const s = temizAd(o.isim), tek = daireFit(s, aile, 400, cx, cy, rk, enB), par = ikiyeBol(s, aile, 400);
  if (par) {
    const iki = satirFit(par, aile, 400, cx, cy, rk, enB);
    if (iki.fs > tek.fs * 1.06) {
      iki.satir.forEach((l) => kaziYazi(g, l.s, l, aile, 400, mini));
      return { fs: iki.fs, en: enB };
    }
  }
  kaziYazi(g, s, tek, aile, 400, mini);
  return { fs: tek.fs, en: enB };
}

/* 11 · MAKROME KORDON — düğümler analitik yerleştirilir (kendi karesel Bézier),
   getPointAtLength yok. Kordon iki yandan çerçeveyi terk eder. */
function bez(p0, p1, p2, t) {
  const u = 1 - t;
  return { x: u*u*p0[0] + 2*u*t*p1[0] + t*t*p2[0], y: u*u*p0[1] + 2*u*t*p1[1] + t*t*p2[1],
    a: Math.atan2(2*u*(p1[1]-p0[1]) + 2*t*(p2[1]-p1[1]), 2*u*(p1[0]-p0[0]) + 2*t*(p2[0]-p1[0])) * 180 / Math.PI };
}
function kordon(g, p0, p1, p2, renk, kal, adim, bosluk, mini) {
  const d = 'M' + y2(p0[0]) + ' ' + y2(p0[1]) + 'Q' + y2(p1[0]) + ' ' + y2(p1[1]) + ' ' + y2(p2[0]) + ' ' + y2(p2[1]);
  el('path', { d, fill:NN, stroke: renk, [SW]: kal }, g);
  el('path', { d, fill:NN, stroke:'rgba(255,255,255,.1)', [SW]: kal*.42 }, g);
  /* Örgü: hücre başına ters yönlü İKİ iplik ucu, biri açık biri koyu. Tek renkli
     tek çentik (b, c) 1x'te düz çizgiye çöküyordu. */
  const n = Math.max(6, Math.round(Math.hypot(p2[0]-p0[0], p2[1]-p0[1]) * 1.06 / adim)), k = kal / 15;
  for (let i = 0; i < n; i++) {
    const t = .025 + .95 * (i + .5) / n;                   /* uçta yarım düğüm kalmasın */
    if (bosluk && t > bosluk[0] && t < bosluk[1]) continue;
    const q = bez(p0, p1, p2, t), yon = i % 2 ? 1 : -1;
    const tf = 'translate(' + y2(q.x) + ' ' + y2(q.y) + ') rotate(' + y2(q.a) + ') scale(' + y2(k) + ')';
    el('path', { d:'M-5.4 ' + y2(5.6*yon) + 'L0 ' + y2(-1.2*yon) + 'L5.4 ' + y2(5.6*yon),
      fill:NN, stroke:'var(--kordon-ic,rgba(255,255,255,.3))', [SW]:2.6, [LC]:RD, [LJ]:RD, transform: tf }, g);
    if (!mini) el('path', { d:'M-5.4 ' + y2(-5.2*yon) + 'L0 ' + y2(1.6*yon) + 'L5.4 ' + y2(-5.2*yon),
      fill:NN, stroke:'var(--kordon-golge,rgba(0,0,0,.42))', [SW]:2.2, [LC]:RD, [LJ]:RD, transform: tf }, g);
  }
}

/* 12 · SAHNELER. Gövde artık ÜRÜNE değil TİPE bağlı: sahibin anahtarlık
   fotoğrafları (initials-charm-1, double-zodiac-charm-1) kolyedeki parçanın
   aynısını gösteriyor — yalnız askı donanımı değişiyor. Eski kural ("kesme harf
   yalnız kolyede") harfin kendisinin kolye ucu olduğu, çerçeve bulunmayan
   tasarımdan kalmaydı; çerçeveli parça her gövdede takılabilir.
     cerceve  → iki/tek harf: ince açık halka + kilitli harfler
     levha    → farklı zodyak: iki kare panelli dikdörtgen plaka
     madalyon → isim ve TEK burç: sahibin ayrıca onayladığı yuvarlak madalyon */
const govdeTipi = (o) => (o.tip === 'tek-harf' || o.tip === 'iki-harf') ? 'cerceve'
  : (o.tip === 'farkli-zodyak') ? 'levha' : 'madalyon';
function icerikVar(o) {
  switch (o.tip) {
    case 'tek-harf': return harfle(o.harfler, 1).length > 0;
    case 'iki-harf': return harfle(o.harfler, 2).length >= 2;
    case 'tek-isim': return !!temizAd(o.isim);
    case 'iki-isim': return !!temizAd(o.isim) && !!temizAd(o.isim2);
    case 'zodyak': return !!BURCLAR[o.burc];
    case 'farkli-zodyak': return !!BURCLAR[o.burc] && !!BURCLAR[o.burc2];
  }
  return false;
}
const dusus = (cm, D) => ((cm == null ? 52.5 : cm) - 52.5) * D.pxCm;
const HAYALET = { 'tek-harf':'A', 'iki-harf':'AB' };
/* İsim/burç ürününde madalyon girişten bağımsız VARDIR: metal basılır, yalnız
   kazıma alanı kesik hatlı kılavuzla gösterilir. */
function bosAlan(g, cx, cy, r, mini) {
  el('circle', { cx, cy, r: r * KAZI_R, fill:NN, stroke:'var(--eos-gold-deep,#A8813F)',
    [SW]: mini ? 1 : 1.5, [DA]: mini ? '3 3' : '7 6', opacity:.5 }, g);
}

function sahneKolye(g, defsG, id, ek, o, aile, D, bos) {
  const yb = D.yb + dusus(o.zincirCm, D), gZ = el('g', null, g), gP = el('g', null, g);
  const gt = govdeTipi(o);
  let sonuc;
  if (gt === 'cerceve') {
    /* Askı zinciri: zincir → halka → parçanın kendi tabı. Fotoğrafta tabın
       merkezi halkanın hemen altında, parça merkezi tabın 1,09 R altında. */
    const R = D.cR, hs = Array.from(bos ? (HAYALET[o.tip] || 'AB') : harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1));
    const cy = yb + D.hR * 1.9 + R * CER.tabY;
    halka(gP, id, D.cx, yb + D.hR, D.hR, D.mini);
    sonuc = cerceveUc(gP, defsG, id, ek, hs, aile, D.cx, cy, R, D.mini, bos, o.susleme !== false);
    zincir(gZ, kolyeD(D.W, D.zUst, yb, D.cx), id, D.zKal, D.zAdim, D.mini);
  } else if (gt === 'levha' && !(o.varyant === 'iki-madalyon' && !bos)) {
    /* Levhanın askısı AYRI bir halka değildir: fotoğrafta zincir doğrudan
       levhaya kaynaklı halkadan geçiyor, arada ikinci bir halka yok. */
    const W = D.lW, bR = W * LEV.tabR, bCy = yb + bR * .74;
    halka(gP, id, D.cx, bCy, bR, D.mini);
    sonuc = levhaUc(gP, defsG, id, ek, o, D.cx, bCy + W * LEV.tabY, W, D.mini, bos);
    zincir(gZ, kolyeD(D.W, D.zUst, yb, D.cx), id, D.zKal, D.zAdim, D.mini);
  } else if (o.tip === 'farkli-zodyak' && o.varyant === 'iki-madalyon' && !bos) {
    /* Tüccarın tek ayarla geçebileceği alternatif (varyant:"iki-madalyon").
       Zincirler eşit değil ve kavisli: iki dik çizgi "diyagram" okunur. */
    const r2 = D.r * .66, ax = D.cx - r2*.82, ay = yb + D.hR*2 + r2*1.34, bx = D.cx + r2*.82, by = ay + r2*.3;
    halka(gP, id, D.cx, yb + D.hR, D.hR, D.mini);
    [[ax, ay, o.burc, 0], [bx, by, o.burc2, 1]].forEach((q) => {
      zincir(gP, 'M' + y2(D.cx) + ' ' + y2(yb + D.hR*1.6) + 'Q' + y2(D.cx + (q[0]-D.cx)*.68) + ' ' +
        y2((yb + q[1])/2) + ' ' + y2(q[0]) + ' ' + y2(q[1] - r2 - D.hR*1.5), id, D.zKal*.78, D.zAdim*.78, D.mini);
      halka(gP, id, q[0], q[1] - r2 - D.hR*.66, D.hR*.72, D.mini);
      kulp(gP, id, q[0], q[1] - r2, r2);
      madalyon(gP, defsG, id, ek + 'v' + q[3], q[0], q[1], r2, D.mini);
      kaziGlif(gP, q[2], q[0], q[1], r2*.62, D.mini);
    });
    zincir(gZ, kolyeD(D.W, D.zUst, yb, D.cx), id, D.zKal, D.zAdim, D.mini);
    sonuc = { fs: r2*.62, en: r2*.62 };
  } else {
    const cy = yb + D.hR*1.9 + D.r*.15 + D.r;
    kulp(gP, id, D.cx, cy - D.r, D.r);
    halka(gP, id, D.cx, yb + D.hR, D.hR, D.mini);
    madalyon(gP, defsG, id, ek, D.cx, cy, D.r, D.mini);
    if (bos) { bosAlan(gP, D.cx, cy, D.r, D.mini); sonuc = { fs:0, en:1 }; }
    else sonuc = madalyonIcerik(gP, defsG, id, ek, o, D.cx, cy, D.r, aile, D.mini);
    zincir(gZ, kolyeD(D.W, D.zUst, yb, D.cx), id, D.zKal, D.zAdim, D.mini);
  }
  return sonuc;
}

/* Ayarlanabilir uç: fotoğrafta örgü kareyi terk etmez, iki yanda ince tel
   olarak çıkar ve her telin ucunda küçük bir metal boncuk durur. Boncuk bu
   parçanın kapanma biçimidir (kayar düğüm), süs değil — çizimden düşerse
   müşteri bilekliğin nasıl ayarlandığını göremez. */
function ucBoncuk(g, D, p, yon) {
  const bx = p[0] + yon * D.W * .085, by = p[1] - D.H * .075, r = D.kKal * .40;
  el('path', { d:'M' + y2(p[0]) + ' ' + y2(p[1]) + 'Q' + y2(p[0] + yon * D.W * .05) + ' ' +
    y2(p[1] - D.H * .015) + ' ' + y2(bx) + ' ' + y2(by),
    fill:NN, stroke: KORDON, [SW]: D.kKal * .32, [LC]:RD }, g);
  el('circle', { cx: bx + yon * r * .85, cy: by, r, fill:V('m1'), stroke:V('rim'), [SW]: r * .16 }, g);
  if (!D.mini) el('circle', { cx: bx + yon * r * .5, cy: by - r * .34, r: r * .34, fill:V('m2'), opacity:.7 }, g);
}

/* Bileklik gövdesi: fotoğrafta örgü bir ÇEMBER YAYIDIR — uçları yukarı kıvrılan
   bir U, yassı bir kavis değil. Yay tek bir çemberden türetilir, böylece Liquid
   çerçevesi aynı yolu tek bir `A` komutuyla basabilir (Liquid'de trigonometri
   yok; düğümleri yalnız JS yerleştirir). Uçlar `kY`, dip `kBel`. */
function yayGeo(D) {
  const x0 = D.W * .18, dx = D.cx - x0, h = D.kBel - D.kY;
  return { x0, x1: D.W - x0, y0: D.kY, R: (dx * dx + h * h) / (2 * h), cy: D.kBel - (dx * dx + h * h) / (2 * h) };
}
function kordonYay(g, D, geo, renk, bosAci, mini) {
  const d = 'M' + y2(geo.x0) + ' ' + y2(geo.y0) + 'A' + y2(geo.R) + ' ' + y2(geo.R) +
    ' 0 1 0 ' + y2(geo.x1) + ' ' + y2(geo.y0);
  el('path', { d, fill:NN, stroke: renk, [SW]: D.kKal }, g);
  el('path', { d, fill:NN, stroke:'rgba(255,255,255,.1)', [SW]: D.kKal * .42 }, g);
  let a0 = Math.atan2(geo.y0 - geo.cy, geo.x0 - D.cx);
  const a1 = Math.atan2(geo.y0 - geo.cy, geo.x1 - D.cx);
  if (a0 < a1) a0 += 2 * Math.PI;   /* sol uç merkezin ÜSTÜNDE: yay dipten geçer */
  const yarim = Math.PI / 2, n = Math.max(8, Math.round(geo.R * (a0 - a1) / D.orgu)), k = D.kKal / 21;
  for (let i = 0; i < n; i++) {
    const a = a0 - (a0 - a1) * (i + .5) / n;
    if (bosAci && Math.abs(a - yarim) < bosAci) continue;
    const x = D.cx + geo.R * Math.cos(a), y = geo.cy + geo.R * Math.sin(a), yon = i % 2 ? 1 : -1;
    const tf = 'translate(' + y2(x) + ' ' + y2(y) + ') rotate(' + y2((a - yarim) * 180 / Math.PI) +
      ') scale(' + y2(k) + ')';
    el('path', { d:'M-5.4 ' + y2(5.6*yon) + 'L0 ' + y2(-1.2*yon) + 'L5.4 ' + y2(5.6*yon),
      fill:NN, stroke:'var(--kordon-ic,rgba(255,255,255,.3))', [SW]:2.6, [LC]:RD, [LJ]:RD, transform: tf }, g);
    el('path', { d:'M-5.4 ' + y2(-5.2*yon) + 'L0 ' + y2(1.6*yon) + 'L5.4 ' + y2(-5.2*yon),
      fill:NN, stroke:'var(--kordon-golge,rgba(0,0,0,.42))', [SW]: mini ? 1.8 : 2.2, [LC]:RD, [LJ]:RD, transform: tf }, g);
  }
}

/* DÜZ PARÇA — parçanın KENDİSİ, askı donanımı olmadan, kareye ortalanmış.
   Referans akışta önizleme karesi de böyledir: zincir uzunluğu ayrı bir adımda
   fotoğrafla, renk yine ayrı bir adımda anlatılır; bu kare yalnız "harflerin bu
   parçada nasıl duruyor" sorusunu cevaplar. Renk düzleştirmesi CSS'tedir
   (`[data-stil='duz']`), geometri aynı kalır — bu yüzden metal moda dönmek tek
   nitelik yazımıdır. */
function sahneParca(g, defsG, id, ek, o, aile, D, bos) {
  const R = Math.min(D.W, D.H) * (D.mini ? .34 : .33);
  const cx = D.cx, cy = D.H * .52;
  const hs = Array.from(bos ? (HAYALET[o.tip] || 'AB') : harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1));
  return cerceveUc(g, defsG, id, ek, hs, aile, cx, cy, R, D.mini, bos, o.susleme !== false, true, true);
}

/* İKİ HARF — tedarikçinin kendi çizimi. Her sırasız harf çifti için bir SVG
   silüet Files kütüphanesinde durur (`eos-m-ES.svg`); tedarikçinin PNG'sinden
   izlenmiştir, kaynakla örtüşmesi %98'in üstündedir. Dosya adı alfabetik
   sıradadır: "S E" yazan müşteri ES parçasını görür, harf satırı onun
   yazdığı sırayı gösterir. Yalnız A–Z vardır — Ç, Ğ, İ, Ö, Ş, Ü içeren çift
   için hazır çizim yoktur ve uydurulmaz. Liquid çerçevesi aynı kuralı uygular
   (`snippets/eos-onizleme-cerceve.liquid`). */
const MONOGRAM_AZ = /^[A-Z]{2}$/;
const MONOGRAM_YOK = 'Bu harf çifti için hazır önizleme yok; tasarımın 24 saat içinde onayına gelir.';

function monogramAnahtar(harfler) {
  return Array.from(harfler).sort().join('');
}

function monogramAdres(anahtar) {
  const kok = (typeof window !== 'undefined' && window.EOS_MONOGRAM_KOK) || '/cdn/shop/files/';
  return kok + 'eos-m-' + anahtar + '.svg';
}

/* Döner: true = çizim var, false = bu çift için yok. */
function sahneMonogram(g, o, D, bos) {
  const yazilan = harfle(o.harfler, 2);
  const destekli = !bos && MONOGRAM_AZ.test(yazilan);
  const anahtar = destekli ? monogramAnahtar(yazilan) : HAYALET['iki-harf'];
  const w = D.W * .84, h = D.H * .84;
  el('image', { href: monogramAdres(anahtar), x: (D.W - w) / 2, y: D.H * .08, width: w, height: h,
    preserveAspectRatio: 'xMidYMid meet', opacity: destekli ? null : .16,
    'class': 'eos-onz-monogram' }, g);
  return destekli;
}

/* ÇİFT BURÇ — tedarikçinin kendi çizimi (`eos-z-<üst>-<alt>.svg`, 144 SIRALI
   çift: birinci burç üst panelde, ikinci alt panelde). charmlry önizleme
   PNG'lerinden izlenmiştir, kaynakla örtüşme ortalama %97,7. Liquid çerçevesi
   aynı kuralı uygular (`snippets/eos-onizleme-cerceve.liquid`). Boşken soluk
   bir örnek (Koç + Aslan) durur. */
function zodyakAdres(ust, alt) {
  const kok = (typeof window !== 'undefined' && window.EOS_MONOGRAM_KOK) || '/cdn/shop/files/';
  return kok + 'eos-z-' + ust + '-' + alt + '.svg';
}

function sahneZodyak(g, o, D, bos) {
  const destekli = !bos && !!BURCLAR[o.burc] && !!BURCLAR[o.burc2];
  const w = D.W * .84, h = D.H * .84;
  el('image', { href: destekli ? zodyakAdres(o.burc, o.burc2) : zodyakAdres('koc', 'aslan'),
    x: (D.W - w) / 2, y: D.H * .08, width: w, height: h,
    preserveAspectRatio: 'xMidYMid meet', opacity: destekli ? null : .16,
    'class': 'eos-onz-monogram' }, g);
  return true;
}

function sahneBileklik(g, defsG, id, ek, o, aile, D, bos) {
  const geo = yayGeo(D), m = { x: D.cx, y: D.kBel };
  const gt = govdeTipi(o);
  const gen = gt === 'cerceve' ? D.kCR * 2 : gt === 'levha' ? D.kLW : D.kR * 2;
  kordonYay(g, D, geo, o.kordonRengi || KORDON, Math.asin(Math.min(1, (gen / 2 + D.kKal * .5) / geo.R)), D.mini);
  ucBoncuk(g, D, [geo.x0, geo.y0], -1);
  ucBoncuk(g, D, [geo.x1, geo.y0], 1);
  /* Kordon parçanın ARKASINDAN geçer; yanlardaki halkalar dizilerek takıldığını
     anlatır (b'de disk kordonun üstüne yapıştırılmış görünüyordu). */
  [-1, 1].forEach((s) => halka(g, id, m.x + s * (gen / 2 + D.kKal * .26), m.y, D.kKal * .34, D.mini));
  if (gt === 'cerceve') {
    const hs = Array.from(bos ? (HAYALET[o.tip] || 'AB') : harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1));
    return cerceveUc(g, defsG, id, ek, hs, aile, m.x, m.y, D.kCR, D.mini, bos, o.susleme !== false, false);
  }
  if (gt === 'levha') return levhaUc(g, defsG, id, ek, o, m.x, m.y - D.kLW * LEV.h / 2, D.kLW, D.mini, bos);
  const r = D.kR;
  madalyon(g, defsG, id, ek, m.x, m.y, r, D.mini);
  if (bos) { bosAlan(g, m.x, m.y, r, D.mini); return { fs:0, en:1 }; }
  return madalyonIcerik(g, defsG, id, ek, o, m.x, m.y, r, aile, D.mini);
}

/* ANAHTARLIK. Fotoğraf (initials-charm-1, double-zodiac-charm-1): YASSI yarık
   halka → küçük bağlantı halkası → 3-4 KABA oval halka → parçanın kendisi.
   Eski çizimdeki "iki küçük halka + kocaman madalyon" hiyerarşisi yanlıştı:
   gerçekte yarık halka parçanın neredeyse çapı kadardır (152 px / 162 px) ve
   zincir kalın. Parça ölçüleri bu yüzden yarık halkadan TÜRETİLİR. */
function sahneAnahtarlik(g, defsG, id, ek, o, aile, D, bos) {
  const cx = D.cx, gt = govdeTipi(o), n = D.ahN, marj = D.mini ? 2 : 4;
  /* Parça boyu yarık halkadan TÜRETİLİR (fotoğraf oranları): çerçeveli/yuvarlak
     parça R/0,94 yarıçapında, levha R/0,591 genişliğinde. Tüm yığın çerçeveye
     sığmazsa YARIK HALKA küçültülür ve her şey onunla birlikte küçülür — böylece
     tek bir oran bile bozulmaz, yalnız mutlak ölçek düşer. (4:3 çerçeve ile
     3:1 oranındaki gerçek parça arasındaki gerilimin dürüst çözümü budur.) */
  const birim = 2 + 2 * AH.adim * n +
    (gt === 'levha' ? (LEV.tabY + LEV.h) / .591 : (gt === 'cerceve' ? CER.tabY + 1 : 2.15) / .94);
  const R = Math.min(D.ahR, (D.H - 2 * marj) / birim), Ds = 2 * R, adim = Ds * AH.adim;
  const Rp = R / .94, W = R / .591, Hl = W * LEV.h;
  const alt = gt === 'levha' ? W * LEV.tabY + Hl : Rp * (gt === 'cerceve' ? CER.tabY + 1 : 2.15);
  const toplam = 2 * R + adim * n + alt;
  const cy = Math.max(R + marj, (D.H - toplam) / 2 + R);
  yarikHalka(g, id, cx, cy, R, D.mini);
  const ask = kabaZincir(g, id, cx, cy + R, Ds, n, D.mini);
  if (gt === 'cerceve') {
    const hs = Array.from(bos ? (HAYALET[o.tip] || 'AB') : harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1));
    return cerceveUc(g, defsG, id, ek, hs, aile, cx, ask + Rp * CER.tabY, Rp, D.mini, bos, o.susleme !== false);
  }
  if (gt === 'levha') {
    halka(g, id, cx, ask, W * LEV.tabR, D.mini);
    return levhaUc(g, defsG, id, ek, o, cx, ask + W * LEV.tabY, W, D.mini, bos);
  }
  const my = ask + Rp * .15 + Rp;
  kulp(g, id, cx, my - Rp, Rp);
  madalyon(g, defsG, id, ek, cx, my, Rp, D.mini);
  if (bos) { bosAlan(g, cx, my, Rp, D.mini); return { fs:0, en:1 }; }
  return madalyonIcerik(g, defsG, id, ek, o, cx, my, Rp, aile, D.mini);
}

/* 13 · ERİŞİLEBİLİRLİK. Hep "Temsili önizleme:" ile başlar, "Çizimdir…" ile biter.
   Gövde adı govdeTipi()'nden TÜRETİLİR: sabit "kolye ucu" yazmak bilekliği kolye
   diye anons ettiriyordu (b'nin kusuru). */
function etiket(o, bos) {
  const gt = govdeTipi(o);
  const tas = gt === 'cerceve' ? 'yuvarlak açık çerçeve'
    : gt === 'levha' ? 'dikdörtgen levha' : 'yuvarlak madalyon';
  let g;
  if (bos) g = (o.tip === 'tek-harf' || o.tip === 'iki-harf') ? 'henüz harf girilmedi'
    : (o.tip === 'tek-isim' || o.tip === 'iki-isim') ? 'henüz isim girilmedi' : 'henüz burç seçilmedi';
  else if (o.tip === 'tek-harf' || o.tip === 'iki-harf') {
    const h = harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1);
    const n = 'metalden kesilmiş ince ' + tas + 'nin içinde';
    g = h.length > 1 ? n + ' iç içe geçmiş ' + h.charAt(0) + ' ve ' + h.charAt(1) + ' harfleri'
                     : n + ' ' + h + ' harfi';
  } else if (o.tip === 'tek-isim') g = tas + 'a kazınmış ' + temizAd(o.isim) + ' yazısı';
  else if (o.tip === 'iki-isim') g = tas + 'a iç içe kazınmış ' + temizAd(o.isim) + ' ve ' + temizAd(o.isim2) + ' yazıları';
  else if (o.tip === 'zodyak') g = tas + 'a kazınmış ' + (BURCLAR[o.burc] || BURCLAR.koc).ad + ' burcu sembolü';
  else if (o.tip === 'farkli-zodyak') g = (o.varyant === 'iki-madalyon' && o.urun === 'kolye'
    ? 'iki ayrı madalyona kazınmış ' : 'iki kare panele delik işi olarak işlenmiş ') +
    (BURCLAR[o.burc] || BURCLAR.koc).ad + ' ve ' + (BURCLAR[o.burc2] || BURCLAR.koc).ad + ' burç motifleri';
  else g = 'kişiye özel takı';
  return 'Temsili önizleme: ' +
    (String(o.renkAdi || '').trim() || RENK_AD[o.renk] || RENK_AD.gold) + ' renkli ' + (URUN_AD[o.urun] || 'kolye') +
    ', ' + g + ((o.urun === 'kolye' && o.zincirCm) ? ', ' + o.zincirCm + ' santimetre zincir' : '') +
    '. Çizimdir, gerçek ürün fotoğrafı değildir.';
}
const CAGRI = {
  'tek-harf':'Harfini yaz — önizleme burada oluşacak.',
  'iki-harf':'İki harfini yaz — önizleme burada oluşacak.',
  'tek-isim':'İsmini yaz — madalyona kazınmış hâlini gör.',
  'iki-isim':'İki ismi yaz — tek madalyona iç içe kazınır.',
  'zodyak':'Burcunu seç.',
  'farkli-zodyak':'İki burcu seç.'
};

/* 14 · GENEL API ----------------------------------------------------------- */
const VARSAYILAN = {
  tip:'iki-harf', urun:'kolye', renk:'gold', zincirCm:50,
  harfler:'', isim:'', isim2:'', burc:'', burc2:'',
  bos:false, olcek:'hero', varyant:'tek-madalyon', kordonRengi:null, yaziTipi:null, susleme:true,
  /* 'duz' = referans akıştaki gibi tek renk kontur ve yalnız parçanın kendisi;
     'metal' = zinciriyle/ipiyle tam sahne, metal gölgelendirmeli. */
  stil:'metal',
  /* Tema eklentileri. `etiket` dürüstlük altyazısının METNİDİR, anahtarı değil:
     boş bırakılırsa varsayılan basılır, kapatmanın yolu yoktur. `renkAdi` aria
     cümlesinde kullanılır ki Liquid çerçevesiyle birebir aynı metin çıksın. */
  etiket:'', cagriMetni:null, renkAdi:''
};
/* 0 = tam (yazı tipi kapısı da yenilenir) · 1 = yalnız sahne grubu ·
   2 = yalnız renk (TEK nitelik yazımı, sıfır DOM). */
const SEVIYE = { yaziTipi:0, olcek:1, tip:1, urun:1, zincirCm:1, harfler:1, isim:1, isim2:1,
                 burc:1, burc2:1, bos:1, varyant:1, kordonRengi:1, susleme:1, renk:2, stil:1,
                 etiket:1, cagriMetni:1, renkAdi:2 };
const ETIKET_VARSAYILAN = 'Temsili önizleme';
/* Düz çizim yalnız ÇERÇEVELİ (harf) parçada geçerlidir: madalyon ve levha
   gövdesinde kazıma tek renkte kaybolur — siyah diskin üstündeki siyah yazı
   okunmaz. O gövdeler metal kalır. */
const duzMu = (o) => o.stil === 'duz' && (o.tip === 'tek-harf' || o.tip === 'iki-harf' || o.tip === 'farkli-zodyak');

export function sahne(host, secenekler) {
  if (typeof host === 'string') host = document.querySelector(host);
  if (!host) throw new Error('EOSOnizleme: host bulunamadı');
  const no = ++SAYAC, id = 'eo' + no + '-';
  const o = Object.assign({}, VARSAYILAN, secenekler || {});
  let D = OLCU[o.olcek === 'mini' ? 'mini' : 'hero'];
  let olu = false, fontTamam = false, aile = '', durum = { punto:1, cokUzun:false };

  const kutu = document.createElement('figure');
  kutu.className = 'eos-onz-kutu';
  const svg = el('svg', { xmlns: NS, 'class':'eos-onz', role:'img', lang:'tr', focusable:'false',
    viewBox:'0 0 ' + D.W + ' ' + D.H, preserveAspectRatio:'xMidYMid meet',
    'data-renk': finisAnahtar(o.renk), 'data-olcek': D.mini ? 'mini' : 'hero',
    'data-stil': duzMu(o) ? 'duz' : 'metal' });
  try { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) svg.setAttribute('data-hareket', 'kapali'); } catch (_) { }
  degradeler(el('defs', null, svg), id);
  const defsG = el('defs', null, svg);       /* her çizimde temizlenir */
  let sahneG = el('g', null, svg);
  kutu.appendChild(svg);
  /* Dürüstlük etiketi MODÜLÜN sorumluluğudur ve kapatılamaz. HTML'de durur:
     çevrilebilir, viewBox ile ölçeklenmez, text-transform'a bağlı değil —
     c'nin "TEMSİLİ ÖNİZ LEME" hatası tam oradan çıkmıştı. */
  /* Harf satırı: referans akışta da çizimin altında "E + S" durur. Çizimin
     İÇİNE yazılmaz — viewBox ile ölçeklenip 13 px'in altına düşerdi. */
  const harfSatiri = document.createElement('p');
  harfSatiri.className = 'eos-onz-harfler';
  kutu.appendChild(harfSatiri);
  const not = document.createElement('figcaption');
  not.className = 'eos-onz-not';
  const cagri = document.createElement('p');
  cagri.className = 'eos-onz-cagri';
  kutu.appendChild(not);
  kutu.appendChild(cagri);
  host.appendChild(kutu);

  function aileBul() {
    if (o.yaziTipi) return aileNormalle(o.yaziTipi);
    let v = '';
    try {
      /* Önce çizimin kendi yüz jetonu (monogram için ayrı bir el yazısı yüz
         seçilebilir), yoksa temanın başlık yüzü. Ölçüm ile çizim aynı yüzü
         kullanmalı: ayrışırsa harfler kutuya sığmaz. */
      v = (getComputedStyle(host).getPropertyValue('--eos-onz-yazi') || '').trim();
      if (!v) v = (getComputedStyle(host).getPropertyValue('--font-heading--family') || '').trim();
      if (!v) v = (getComputedStyle(document.documentElement).getPropertyValue('--eos-onz-yazi') || '').trim();
      if (!v) v = (getComputedStyle(document.documentElement).getPropertyValue('--font-heading--family') || '').trim();
    } catch (_) { }
    return aileNormalle(v || '"Playfair Display", Georgia, "Times New Roman", serif');
  }

  function ciz() {
    D = OLCU[o.olcek === 'mini' ? 'mini' : 'hero'];
    /* Aile HER çizimde çözülür: host DocumentFragment içinde kurulmuş olabilir. */
    aile = aileBul();
    svg.setAttribute('viewBox', '0 0 ' + D.W + ' ' + D.H);
    svg.setAttribute('data-olcek', D.mini ? 'mini' : 'hero');
    svg.setAttribute('data-renk', finisAnahtar(o.renk));
    svg.setAttribute('data-stil', duzMu(o) ? 'duz' : 'metal');
    kutu.setAttribute('data-olcek', D.mini ? 'mini' : 'hero');
    defsG.textContent = '';
    const yeni = el('g', null, null);
    el('rect', { x:0, y:0, width: D.W, height: D.H, fill:'var(--eos-ivory, #FBF9F6)' }, yeni);
    /* bos çağırandan gelmese de içerikten TÜRETİLİR: metale "Ad" gibi bir yer
       tutucu asla kazınmaz (c'nin kusuru). */
    const bos = o.bos === true || !icerikVar(o);
    const monogram = duzMu(o) && o.tip === 'iki-harf';
    const zodyak = duzMu(o) && o.tip === 'farkli-zodyak';
    const cizimVar = monogram ? sahneMonogram(yeni, o, D, bos)
      : zodyak ? sahneZodyak(yeni, o, D, bos) : true;
    const s = (monogram || zodyak) ? null
      : duzMu(o) ? sahneParca(yeni, defsG, id, no, o, aile, D, bos)
      : o.urun === 'bileklik' ? sahneBileklik(yeni, defsG, id, no, o, aile, D, bos)
      : o.urun === 'anahtarlik' ? sahneAnahtarlik(yeni, defsG, id, no, o, aile, D, bos)
      : sahneKolye(yeni, defsG, id, no, o, aile, D, bos);
    svg.replaceChild(yeni, sahneG);
    sahneG = yeni;
    const oran = bos ? 1 : (s && s.en ? s.fs / s.en : 1);
    durum = { punto: oran, cokUzun: !bos && oran < .32 };
    svg.setAttribute('aria-label', etiket(o, bos));
    /* Altyazı Liquid çerçevesiyle KELİMESİ KELİMESİNE aynı kurulur; yoksa JS
       bağlandığı anda yazı değişir ve göz "bir şey bozuldu" der. */
    harfSatiri.textContent = !duzMu(o) || bos ? ''
      : zodyak ? (BURCLAR[o.burc] || {}).ad + ' + ' + (BURCLAR[o.burc2] || {}).ad
      : harfle(o.harfler, o.tip === 'iki-harf' ? 2 : 1).split('').join(' + ');
    harfSatiri.hidden = !harfSatiri.textContent;
    not.textContent = (String(o.etiket || '').trim() || ETIKET_VARSAYILAN) +
      (!duzMu(o) && o.urun === 'kolye' && o.zincirCm ? ' · ' + o.zincirCm + ' cm zincir' : '');
    cagri.textContent = (bos && !D.mini)
      ? (o.cagriMetni != null ? String(o.cagriMetni) : (CAGRI[o.tip] || ''))
      /* Mini ölçekte de basılır: ürün sayfasının canlı sahnesi mini'dir ve not
         tam orada gerekir. Sepetin küçük resmi yalnız Liquid'dir, orada yok. */
      : (!bos && !cizimVar ? MONOGRAM_YOK : '');
    cagri.hidden = !cagri.textContent;
  }
  ciz();

  /* Yazı tipi kapısı. Hazırlık yalnız İLK aileye sorulur: listenin sonundaki
     serif hep hazırdır ve kapıyı yalan yere açar (a'nın kusuru).
     document.fonts.ready motordan bağımsız yedek. Promise, rAF değil. */
  function fontKapisi() {
    if (typeof document === 'undefined' || !document.fonts || !document.fonts.load) return;
    const ilk = aile.split(',')[0].trim(), ORN = 'ŞĞİÇÖÜAyşegül';
    const ks = ['400 40px ' + ilk, '500 40px ' + ilk, KESIM_STIL + ' ' + KESIM_AG + ' 40px ' + ilk];
    const yenile = () => { if (!olu && !fontTamam) { fontTamam = true; ciz(); } };
    try {
      if (document.fonts.check && ks.every((k) => document.fonts.check(k, ORN))) { fontTamam = true; return; }
      Promise.all(ks.map((k) => document.fonts.load(k, ORN))).then(yenile, () => { });
      if (document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(yenile, () => { });
    } catch (_) { }
  }
  fontKapisi();

  return {
    svg, kutu,
    get secenekler() { return Object.assign({}, o); },
    /* "Bu isim bu modele sığmıyor" uyarısının tek dürüst sinyali. Mesajı HOST
       yazar; çizimin içine hata basılmaz. */
    get durum() { return { punto: durum.punto, cokUzun: durum.cokUzun }; },
    guncelle(kismi) {
      if (olu || !kismi) return this;
      let sv = 3;
      for (const k in kismi) {
        if (!(k in VARSAYILAN) || o[k] === kismi[k]) continue;
        o[k] = kismi[k];
        const s = SEVIYE[k];
        if (s != null && s < sv) sv = s;
      }
      if (sv === 3) return this;
      if (sv === 2) {
        /* Ucuz yol: TEK nitelik yazımı; duraklar var(--mN) okur, sıfır DOM. */
        svg.setAttribute('data-renk', finisAnahtar(o.renk));
        svg.setAttribute('aria-label', etiket(o, o.bos === true || !icerikVar(o)));
        return this;
      }
      if (sv === 0) { fontTamam = false; ciz(); fontKapisi(); } else ciz();
      return this;
    },
    destroy() { if (!olu) { olu = true; if (kutu.parentNode) kutu.parentNode.removeChild(kutu); } }
  };
}

/* 15 · ÖZEL ELEMAN — `<eos-onizleme>` ======================================
   Sahne kendi durumunu ÇEKER (pull), olay beklemez. Sebebi Horizon: her renk /
   zincir tıklamasında `<media-gallery>` bağlamsız bir adresten gelen kopyasıyla
   DEĞİŞTİRİLİR, tema editörü bölümü baştan basar, ve bu modül
   `fetchpriority="low"` ile geç yüklenir — yani "bir kere bağlan, olayı bekle"
   kurgusu birbirinden bağımsız üç yoldan sessizce ölür. Bağlandığı anda DOM'dan
   okuyan bir eleman üçünde de kendini doğru boyar.

   Sunucuda basılan çerçeve (snippets/eos-onizleme-cerceve.liquid) bu elemanın
   İÇİNDEDİR; JS bağlanınca onu ölçülmüş sürümüyle değiştirir. JS hiç çalışmazsa
   çerçeve olduğu gibi kalır ve sayfa yine dürüst bir çizim gösterir.

   Bu dosya `snippets/eos-onizleme-stil.liquid` olmadan mount EDİLMEZ: bitiş
   jetonları oradaki CSS'te yaşar ve ana ton tema ayarından gelir. */

const TR_HARF = { 'ı': 'i', 'ğ': 'g', 'ü': 'u', 'ş': 's', 'ö': 'o', 'ç': 'c' };
/* Shopify `handleize` filtresinin bu değerler için karşılığı: "Rose Gold" →
   "rose-gold". Liquid ile JS aynı jetonu üretmezse bitiş sessizce altına düşer
   ve kimse fark etmez, çünkü altın da geçerli bir görüntüdür. */
function anahtarla(v) {
  return nfc(v)
    .toLocaleLowerCase('tr-TR')
    .replace(/[ığüşöç]/g, (c) => TR_HARF[c] || c)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
const ONIZ_TIPLER = ['tek-harf', 'iki-harf', 'tek-isim', 'iki-isim', 'zodyak', 'farkli-zodyak'];
const ONIZ_AILELER = ['kolye', 'bileklik', 'anahtarlik'];

export class EOSOnizlemeSahne extends HTMLElement {
  #c = null;
  #bagli = false;

  connectedCallback() {
    if (this.#bagli) return;
    this.#bagli = true;
    const d = this.dataset;
    /* Tanınmayan tip: sunucu çerçevesine dokunulmaz. Yarı çizilmiş bir sahne
       bırakmaktansa Liquid'in bastığı doğru resmi korumak yeğdir. */
    if (ONIZ_TIPLER.indexOf(d.tip) < 0) return;

    const opts = {
      tip: d.tip,
      urun: ONIZ_AILELER.indexOf(d.aile) > 0 ? d.aile : 'kolye',
      olcek: d.olcek === 'mini' ? 'mini' : 'hero',
      varyant: d.varyant === 'iki-madalyon' ? 'iki-madalyon' : 'tek-madalyon',
      susleme: d.susleme !== 'false',
      stil: d.stil === 'duz' ? 'duz' : 'metal',
      etiket: d.etiket || '',
      cagriMetni: d.cagri != null ? d.cagri : null,
      renk: finisAnahtar(d.renk),
      renkAdi: d.renkAdi || '',
      zincirCm: d.zincir ? parseInt(d.zincir, 10) || null : null
    };
    Object.assign(opts, this.#topla(opts.urun));
    /* Sunucu çerçevesi burada gider: iki figür, iki altyazı olmasın. */
    this.textContent = '';
    this.#c = sahne(this, opts);
    this.#dinle(true);
  }

  disconnectedCallback() {
    this.#dinle(false);
    if (this.#c) {
      this.#c.destroy();
      this.#c = null;
    }
    this.#bagli = false;
  }

  /** Dışarıdan itmek için (kişiselleştirme bloğu kullanır). Eleman henüz
      yükseltilmediyse çağrı hiç olmaz; sorun değil, bağlanınca kendi çeker. */
  guncelle(kismi) {
    if (this.#c) this.#c.guncelle(kismi);
    return this;
  }

  get durum() {
    return this.#c ? this.#c.durum : { punto: 1, cokUzun: false };
  }

  /** Sepete giden `_Onizleme` kaydını yazan taraf buradan okur: varyant
      seçicisini iki ayrı yerde yorumlamak, ikisinin bir gün ayrışması demektir. */
  get secenekler() {
    return this.#c ? this.#c.secenekler : null;
  }

  #dinle(ac) {
    const f = ac ? 'addEventListener' : 'removeEventListener';
    /* capture: Horizon bir bileşenin içinde `change`i durdursa bile önce biz
       görürüz. `input` metin alanları için, `change` radyo ve açılır liste için. */
    document[f]('input', this.#tetik, true);
    document[f]('change', this.#tetik, true);
    document[f]('eos:kisisellestirme:change', this.#tetik);
    document[f]('shopify:product:select', this.#tetik);
  }

  #tetik = (ev) => {
    if (!this.#c) return;
    /* Ürün kartındaki ve hızlı ekleme penceresindeki seçiciler bu ürünü
       anlatmaz; onlara kulak vermek yanlış rengi çizdirir. */
    const t = ev.target;
    if (t && t.closest && (t.closest('product-card') || t.closest('quick-add-dialog'))) return;
    this.#c.guncelle(this.#topla(this.#c.secenekler.urun));
  };

  #kapsam() {
    const sec = this.dataset.kapsam;
    return (sec && document.querySelector(sec)) || document.querySelector('.eos-kis') || null;
  }

  /** DOM'dan okunabilen her şeyi toplar; okunamayanı olduğu gibi bırakır. */
  #topla(aile) {
    const out = {};
    const kis = this.#kapsam();
    if (kis) {
      /* Alan eşlemesi dile BAĞLI DEĞİL: `data-tur` ve `data-bagli` okunur.
         Türkçe property adlarına (İsim, 1. Burç…) seçiciyle dokunmak, adı
         değiştiren ilk düzenlemede sessizce boş bir önizleme verirdi. */
      const alanlar = kis.querySelectorAll('[data-tur][data-bagli]');
      let harfler = '';
      let isim = '';
      let isim2 = '';
      let burc = '';
      let burc2 = '';
      for (let i = 0; i < alanlar.length; i++) {
        const a = alanlar[i];
        if (a.type === 'radio' && !a.checked) continue;
        const ikinci = a.dataset.bagli === '1';
        const deger = a.type === 'radio' ? a.dataset.kod || '' : a.value || '';
        if (a.dataset.tur === 'harf') harfler = deger;
        else if (a.dataset.tur === 'isim') {
          if (ikinci) isim2 = deger;
          else isim = deger;
        } else if (a.dataset.tur === 'burc') {
          if (ikinci) burc2 = deger;
          else burc = deger;
        }
      }
      out.harfler = harfler;
      out.isim = isim;
      out.isim2 = isim2;
      out.burc = burc;
      out.burc2 = burc2;
      if (ONIZ_TIPLER.indexOf(kis.dataset.tip) >= 0) out.tip = kis.dataset.tip;
    }

    /* Renk ve zincir: SEÇİLİ girdi izlenir, ilk görünen kutucuk değil. Kadın /
       Erkek kuralı kutucukları CSS ile gizler ve model seçici seçimi bir
       zamanlayıcıyla kaydırır; görünürlüğe bakan kod yanlış rengi çizer. */
    const picker =
      document.querySelector('variant-picker[data-template-product-match="true"]') ||
      document.querySelector('variant-picker');
    if (picker) {
      const renkAdi = this.dataset.renkSecenek || 'Renk';
      const zincirAdi = this.dataset.zincirSecenek || 'Zincir';
      const adaylar = picker.querySelectorAll('[data-option-name]');
      for (let i = 0; i < adaylar.length; i++) {
        const n = adaylar[i];
        if (n.tagName === 'INPUT') {
          if (!n.checked) continue;
        } else if (n.tagName === 'OPTION') {
          if (!n.selected) continue;
        } else continue;
        const deger = String(n.value || n.textContent || '').trim();
        if (!deger) continue;
        if (n.dataset.optionName === renkAdi) {
          out.renk = anahtarla(deger) || 'gold';
          out.renkAdi = deger;
        } else if (n.dataset.optionName === zincirAdi) {
          const m = deger.match(/\d+/);
          out.zincirCm = m ? parseInt(m[0], 10) : null;
        }
      }
    }
    /* Bileklik ve anahtarlıkta zincir boyu diye bir şey yoktur; altyazıda da
       görünmemeli. */
    if (aile !== 'kolye') out.zincirCm = null;
    return out;
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('eos-onizleme')) {
  customElements.define('eos-onizleme', EOSOnizlemeSahne);
}

/* `burclar` dışarı verilir ki burç listesi çizimle AYNI kaynaktan kurulabilsin
   (araştırma notlarındaki C20 çelişkisi). Bitiş tablosu artık CSS'tedir, o
   yüzden yalnız geçerli jeton adları verilir. */
export const SURUM = 'tema-1.0 (final-1.0)';
export const EOSOnizleme = { sahne, finisler: FINIS_ANAHTARLARI, burclar: BURCLAR, temizAd, harfle, SURUM };
export default EOSOnizleme;
